var V = {};
Object.defineProperty(V, "__esModule", { value: !0 });
function Ot(t, n) {
  for (var i = 0; i < n.length; i++) {
    var e = n[i];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, mn(e.key), e);
  }
}
function U(t, n, i) {
  return n && Ot(t.prototype, n), i && Ot(t, i), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function S() {
  return S = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];
      for (var e in i)
        Object.prototype.hasOwnProperty.call(i, e) && (t[e] = i[e]);
    }
    return t;
  }, S.apply(this, arguments);
}
function W(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, Oe(t, n);
}
function tt(t) {
  return tt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, tt(t);
}
function Oe(t, n) {
  return Oe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
    return e.__proto__ = r, e;
  }, Oe(t, n);
}
function ln() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function We(t, n, i) {
  return ln() ? We = Reflect.construct.bind() : We = function(r, a, o) {
    var u = [null];
    u.push.apply(u, a);
    var s = Function.bind.apply(r, u), l = new s();
    return o && Oe(l, o.prototype), l;
  }, We.apply(null, arguments);
}
function fn(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function rt(t) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return rt = function(e) {
    if (e === null || !fn(e))
      return e;
    if (typeof e != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof n < "u") {
      if (n.has(e))
        return n.get(e);
      n.set(e, r);
    }
    function r() {
      return We(e, arguments, tt(this).constructor);
    }
    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Oe(r, e);
  }, rt(t);
}
function er(t, n) {
  if (t == null)
    return {};
  var i = {}, e = Object.keys(t), r, a;
  for (a = 0; a < e.length; a++)
    r = e[a], !(n.indexOf(r) >= 0) && (i[r] = t[r]);
  return i;
}
function cn(t, n) {
  if (t) {
    if (typeof t == "string")
      return pt(t, n);
    var i = Object.prototype.toString.call(t).slice(8, -1);
    if (i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set")
      return Array.from(t);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
      return pt(t, n);
  }
}
function pt(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var i = 0, e = new Array(n); i < n; i++)
    e[i] = t[i];
  return e;
}
function be(t, n) {
  var i = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (i)
    return (i = i.call(t)).next.bind(i);
  if (Array.isArray(t) || (i = cn(t)) || n && t && typeof t.length == "number") {
    i && (t = i);
    var e = 0;
    return function() {
      return e >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[e++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dn(t, n) {
  if (typeof t != "object" || t === null)
    return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var e = i.call(t, n || "default");
    if (typeof e != "object")
      return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(t);
}
function mn(t) {
  var n = dn(t, "string");
  return typeof n == "symbol" ? n : String(n);
}
var B = /* @__PURE__ */ function(t) {
  W(n, t);
  function n() {
    return t.apply(this, arguments) || this;
  }
  return n;
}(/* @__PURE__ */ rt(Error)), hn = /* @__PURE__ */ function(t) {
  W(n, t);
  function n(i) {
    return t.call(this, "Invalid DateTime: " + i.toMessage()) || this;
  }
  return n;
}(B), vn = /* @__PURE__ */ function(t) {
  W(n, t);
  function n(i) {
    return t.call(this, "Invalid Interval: " + i.toMessage()) || this;
  }
  return n;
}(B), yn = /* @__PURE__ */ function(t) {
  W(n, t);
  function n(i) {
    return t.call(this, "Invalid Duration: " + i.toMessage()) || this;
  }
  return n;
}(B), ne = /* @__PURE__ */ function(t) {
  W(n, t);
  function n() {
    return t.apply(this, arguments) || this;
  }
  return n;
}(B), tr = /* @__PURE__ */ function(t) {
  W(n, t);
  function n(i) {
    return t.call(this, "Invalid unit " + i) || this;
  }
  return n;
}(B), M = /* @__PURE__ */ function(t) {
  W(n, t);
  function n() {
    return t.apply(this, arguments) || this;
  }
  return n;
}(B), q = /* @__PURE__ */ function(t) {
  W(n, t);
  function n() {
    return t.call(this, "Zone is an abstract class") || this;
  }
  return n;
}(B), h = "numeric", z = "short", E = "long", Re = {
  year: h,
  month: h,
  day: h
}, rr = {
  year: h,
  month: z,
  day: h
}, gn = {
  year: h,
  month: z,
  day: h,
  weekday: z
}, nr = {
  year: h,
  month: E,
  day: h
}, ir = {
  year: h,
  month: E,
  day: h,
  weekday: E
}, ar = {
  hour: h,
  minute: h
}, or = {
  hour: h,
  minute: h,
  second: h
}, ur = {
  hour: h,
  minute: h,
  second: h,
  timeZoneName: z
}, sr = {
  hour: h,
  minute: h,
  second: h,
  timeZoneName: E
}, lr = {
  hour: h,
  minute: h,
  hourCycle: "h23"
}, fr = {
  hour: h,
  minute: h,
  second: h,
  hourCycle: "h23"
}, cr = {
  hour: h,
  minute: h,
  second: h,
  hourCycle: "h23",
  timeZoneName: z
}, dr = {
  hour: h,
  minute: h,
  second: h,
  hourCycle: "h23",
  timeZoneName: E
}, mr = {
  year: h,
  month: h,
  day: h,
  hour: h,
  minute: h
}, hr = {
  year: h,
  month: h,
  day: h,
  hour: h,
  minute: h,
  second: h
}, vr = {
  year: h,
  month: z,
  day: h,
  hour: h,
  minute: h
}, yr = {
  year: h,
  month: z,
  day: h,
  hour: h,
  minute: h,
  second: h
}, wn = {
  year: h,
  month: z,
  day: h,
  weekday: z,
  hour: h,
  minute: h
}, gr = {
  year: h,
  month: E,
  day: h,
  hour: h,
  minute: h,
  timeZoneName: z
}, wr = {
  year: h,
  month: E,
  day: h,
  hour: h,
  minute: h,
  second: h,
  timeZoneName: z
}, Sr = {
  year: h,
  month: E,
  day: h,
  weekday: E,
  hour: h,
  minute: h,
  timeZoneName: E
}, kr = {
  year: h,
  month: E,
  day: h,
  weekday: E,
  hour: h,
  minute: h,
  second: h,
  timeZoneName: E
}, ue = /* @__PURE__ */ function() {
  function t() {
  }
  var n = t.prototype;
  return n.offsetName = function(e, r) {
    throw new q();
  }, n.formatOffset = function(e, r) {
    throw new q();
  }, n.offset = function(e) {
    throw new q();
  }, n.equals = function(e) {
    throw new q();
  }, U(t, [{
    key: "type",
    get: (
      /**
       * The type of zone
       * @abstract
       * @type {string}
       */
      function() {
        throw new q();
      }
    )
    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */
  }, {
    key: "name",
    get: function() {
      throw new q();
    }
    /**
     * The IANA name of this zone.
     * Defaults to `name` if not overwritten by a subclass.
     * @abstract
     * @type {string}
     */
  }, {
    key: "ianaName",
    get: function() {
      return this.name;
    }
    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */
  }, {
    key: "isUniversal",
    get: function() {
      throw new q();
    }
  }, {
    key: "isValid",
    get: function() {
      throw new q();
    }
  }]), t;
}(), je = null, lt = /* @__PURE__ */ function(t) {
  W(n, t);
  function n() {
    return t.apply(this, arguments) || this;
  }
  var i = n.prototype;
  return i.offsetName = function(r, a) {
    var o = a.format, u = a.locale;
    return Fr(r, o, u);
  }, i.formatOffset = function(r, a) {
    return ke(this.offset(r), a);
  }, i.offset = function(r) {
    return -new Date(r).getTimezoneOffset();
  }, i.equals = function(r) {
    return r.type === "system";
  }, U(n, [{
    key: "type",
    get: (
      /** @override **/
      function() {
        return "system";
      }
    )
    /** @override **/
  }, {
    key: "name",
    get: function() {
      return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/
  }, {
    key: "isUniversal",
    get: function() {
      return !1;
    }
  }, {
    key: "isValid",
    get: function() {
      return !0;
    }
  }], [{
    key: "instance",
    get: (
      /**
       * Get a singleton instance of the local zone
       * @return {SystemZone}
       */
      function() {
        return je === null && (je = new n()), je;
      }
    )
  }]), n;
}(ue), Le = {};
function Sn(t) {
  return Le[t] || (Le[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), Le[t];
}
var kn = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function Tn(t, n) {
  var i = t.format(n).replace(/\u200E/g, ""), e = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(i), r = e[1], a = e[2], o = e[3], u = e[4], s = e[5], l = e[6], f = e[7];
  return [o, r, a, u, s, l, f];
}
function On(t, n) {
  for (var i = t.formatToParts(n), e = [], r = 0; r < i.length; r++) {
    var a = i[r], o = a.type, u = a.value, s = kn[o];
    o === "era" ? e[s] = u : g(s) || (e[s] = parseInt(u, 10));
  }
  return e;
}
var Ee = {}, Q = /* @__PURE__ */ function(t) {
  W(n, t), n.create = function(r) {
    return Ee[r] || (Ee[r] = new n(r)), Ee[r];
  }, n.resetCache = function() {
    Ee = {}, Le = {};
  }, n.isValidSpecifier = function(r) {
    return this.isValidZone(r);
  }, n.isValidZone = function(r) {
    if (!r)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", {
        timeZone: r
      }).format(), !0;
    } catch {
      return !1;
    }
  };
  function n(e) {
    var r;
    return r = t.call(this) || this, r.zoneName = e, r.valid = n.isValidZone(e), r;
  }
  var i = n.prototype;
  return i.offsetName = function(r, a) {
    var o = a.format, u = a.locale;
    return Fr(r, o, u, this.name);
  }, i.formatOffset = function(r, a) {
    return ke(this.offset(r), a);
  }, i.offset = function(r) {
    var a = new Date(r);
    if (isNaN(a))
      return NaN;
    var o = Sn(this.name), u = o.formatToParts ? On(o, a) : Tn(o, a), s = u[0], l = u[1], f = u[2], c = u[3], d = u[4], m = u[5], v = u[6];
    c === "BC" && (s = -Math.abs(s) + 1);
    var w = d === 24 ? 0 : d, k = $e({
      year: s,
      month: l,
      day: f,
      hour: w,
      minute: m,
      second: v,
      millisecond: 0
    }), y = +a, b = y % 1e3;
    return y -= b >= 0 ? b : 1e3 + b, (k - y) / (60 * 1e3);
  }, i.equals = function(r) {
    return r.type === "iana" && r.name === this.name;
  }, U(n, [{
    key: "type",
    get: function() {
      return "iana";
    }
    /**
     * The name of this zone (i.e. the IANA zone name).
     * @override
     * @type {string}
     */
  }, {
    key: "name",
    get: function() {
      return this.zoneName;
    }
    /**
     * Returns whether the offset is known to be fixed for the whole year:
     * Always returns false for all IANA zones.
     * @override
     * @type {boolean}
     */
  }, {
    key: "isUniversal",
    get: function() {
      return !1;
    }
  }, {
    key: "isValid",
    get: function() {
      return this.valid;
    }
  }]), n;
}(ue), pn = ["base"], bn = ["padTo", "floor"], bt = {};
function Dn(t, n) {
  n === void 0 && (n = {});
  var i = JSON.stringify([t, n]), e = bt[i];
  return e || (e = new Intl.ListFormat(t, n), bt[i] = e), e;
}
var nt = {};
function it(t, n) {
  n === void 0 && (n = {});
  var i = JSON.stringify([t, n]), e = nt[i];
  return e || (e = new Intl.DateTimeFormat(t, n), nt[i] = e), e;
}
var at = {};
function In(t, n) {
  n === void 0 && (n = {});
  var i = JSON.stringify([t, n]), e = at[i];
  return e || (e = new Intl.NumberFormat(t, n), at[i] = e), e;
}
var ot = {};
function Nn(t, n) {
  n === void 0 && (n = {});
  var i = n, e = er(i, pn), r = JSON.stringify([t, e]), a = ot[r];
  return a || (a = new Intl.RelativeTimeFormat(t, n), ot[r] = a), a;
}
var ge = null;
function Mn() {
  return ge || (ge = new Intl.DateTimeFormat().resolvedOptions().locale, ge);
}
var Dt = {};
function En(t) {
  var n = Dt[t];
  if (!n) {
    var i = new Intl.Locale(t);
    n = "getWeekInfo" in i ? i.getWeekInfo() : i.weekInfo, Dt[t] = n;
  }
  return n;
}
function Fn(t) {
  var n = t.indexOf("-x-");
  n !== -1 && (t = t.substring(0, n));
  var i = t.indexOf("-u-");
  if (i === -1)
    return [t];
  var e, r;
  try {
    e = it(t).resolvedOptions(), r = t;
  } catch {
    var a = t.substring(0, i);
    e = it(a).resolvedOptions(), r = a;
  }
  var o = e, u = o.numberingSystem, s = o.calendar;
  return [r, u, s];
}
function xn(t, n, i) {
  return (i || n) && (t.includes("-u-") || (t += "-u"), i && (t += "-ca-" + i), n && (t += "-nu-" + n)), t;
}
function Cn(t) {
  for (var n = [], i = 1; i <= 12; i++) {
    var e = D.utc(2009, i, 1);
    n.push(t(e));
  }
  return n;
}
function Vn(t) {
  for (var n = [], i = 1; i <= 7; i++) {
    var e = D.utc(2016, 11, 13 + i);
    n.push(t(e));
  }
  return n;
}
function Fe(t, n, i, e) {
  var r = t.listingMode();
  return r === "error" ? null : r === "en" ? i(n) : e(n);
}
function Wn(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
var Ln = /* @__PURE__ */ function() {
  function t(i, e, r) {
    this.padTo = r.padTo || 0, this.floor = r.floor || !1;
    var a = er(r, bn);
    if (!e || Object.keys(a).length > 0) {
      var o = S({
        useGrouping: !1
      }, r);
      r.padTo > 0 && (o.minimumIntegerDigits = r.padTo), this.inf = In(i, o);
    }
  }
  var n = t.prototype;
  return n.format = function(e) {
    if (this.inf) {
      var r = this.floor ? Math.floor(e) : e;
      return this.inf.format(r);
    } else {
      var a = this.floor ? Math.floor(e) : ht(e, 3);
      return I(a, this.padTo);
    }
  }, t;
}(), _n = /* @__PURE__ */ function() {
  function t(i, e, r) {
    this.opts = r, this.originalZone = void 0;
    var a = void 0;
    if (this.opts.timeZone)
      this.dt = i;
    else if (i.zone.type === "fixed") {
      var o = -1 * (i.offset / 60), u = o >= 0 ? "Etc/GMT+" + o : "Etc/GMT" + o;
      i.offset !== 0 && Q.create(u).valid ? (a = u, this.dt = i) : (a = "UTC", this.dt = i.offset === 0 ? i : i.setZone("UTC").plus({
        minutes: i.offset
      }), this.originalZone = i.zone);
    } else
      i.zone.type === "system" ? this.dt = i : i.zone.type === "iana" ? (this.dt = i, a = i.zone.name) : (a = "UTC", this.dt = i.setZone("UTC").plus({
        minutes: i.offset
      }), this.originalZone = i.zone);
    var s = S({}, this.opts);
    s.timeZone = s.timeZone || a, this.dtf = it(e, s);
  }
  var n = t.prototype;
  return n.format = function() {
    return this.originalZone ? this.formatToParts().map(function(e) {
      var r = e.value;
      return r;
    }).join("") : this.dtf.format(this.dt.toJSDate());
  }, n.formatToParts = function() {
    var e = this, r = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? r.map(function(a) {
      if (a.type === "timeZoneName") {
        var o = e.originalZone.offsetName(e.dt.ts, {
          locale: e.dt.locale,
          format: e.opts.timeZoneName
        });
        return S({}, a, {
          value: o
        });
      } else
        return a;
    }) : r;
  }, n.resolvedOptions = function() {
    return this.dtf.resolvedOptions();
  }, t;
}(), An = /* @__PURE__ */ function() {
  function t(i, e, r) {
    this.opts = S({
      style: "long"
    }, r), !e && Mr() && (this.rtf = Nn(i, r));
  }
  var n = t.prototype;
  return n.format = function(e, r) {
    return this.rtf ? this.rtf.format(e, r) : ai(r, e, this.opts.numeric, this.opts.style !== "long");
  }, n.formatToParts = function(e, r) {
    return this.rtf ? this.rtf.formatToParts(e, r) : [];
  }, t;
}(), Zn = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
}, O = /* @__PURE__ */ function() {
  t.fromOpts = function(e) {
    return t.create(e.locale, e.numberingSystem, e.outputCalendar, e.weekSettings, e.defaultToEN);
  }, t.create = function(e, r, a, o, u) {
    u === void 0 && (u = !1);
    var s = e || p.defaultLocale, l = s || (u ? "en-US" : Mn()), f = r || p.defaultNumberingSystem, c = a || p.defaultOutputCalendar, d = ut(o) || p.defaultWeekSettings;
    return new t(l, f, c, d, s);
  }, t.resetCache = function() {
    ge = null, nt = {}, at = {}, ot = {};
  }, t.fromObject = function(e) {
    var r = e === void 0 ? {} : e, a = r.locale, o = r.numberingSystem, u = r.outputCalendar, s = r.weekSettings;
    return t.create(a, o, u, s);
  };
  function t(i, e, r, a, o) {
    var u = Fn(i), s = u[0], l = u[1], f = u[2];
    this.locale = s, this.numberingSystem = e || l || null, this.outputCalendar = r || f || null, this.weekSettings = a, this.intl = xn(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = {
      format: {},
      standalone: {}
    }, this.monthsCache = {
      format: {},
      standalone: {}
    }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = o, this.fastNumbersCached = null;
  }
  var n = t.prototype;
  return n.listingMode = function() {
    var e = this.isEnglish(), r = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && r ? "en" : "intl";
  }, n.clone = function(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : t.create(e.locale || this.specifiedLocale, e.numberingSystem || this.numberingSystem, e.outputCalendar || this.outputCalendar, ut(e.weekSettings) || this.weekSettings, e.defaultToEN || !1);
  }, n.redefaultToEN = function(e) {
    return e === void 0 && (e = {}), this.clone(S({}, e, {
      defaultToEN: !0
    }));
  }, n.redefaultToSystem = function(e) {
    return e === void 0 && (e = {}), this.clone(S({}, e, {
      defaultToEN: !1
    }));
  }, n.months = function(e, r) {
    var a = this;
    return r === void 0 && (r = !1), Fe(this, e, Vr, function() {
      var o = r ? {
        month: e,
        day: "numeric"
      } : {
        month: e
      }, u = r ? "format" : "standalone";
      return a.monthsCache[u][e] || (a.monthsCache[u][e] = Cn(function(s) {
        return a.extract(s, o, "month");
      })), a.monthsCache[u][e];
    });
  }, n.weekdays = function(e, r) {
    var a = this;
    return r === void 0 && (r = !1), Fe(this, e, _r, function() {
      var o = r ? {
        weekday: e,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: e
      }, u = r ? "format" : "standalone";
      return a.weekdaysCache[u][e] || (a.weekdaysCache[u][e] = Vn(function(s) {
        return a.extract(s, o, "weekday");
      })), a.weekdaysCache[u][e];
    });
  }, n.meridiems = function() {
    var e = this;
    return Fe(this, void 0, function() {
      return Ar;
    }, function() {
      if (!e.meridiemCache) {
        var r = {
          hour: "numeric",
          hourCycle: "h12"
        };
        e.meridiemCache = [D.utc(2016, 11, 13, 9), D.utc(2016, 11, 13, 19)].map(function(a) {
          return e.extract(a, r, "dayperiod");
        });
      }
      return e.meridiemCache;
    });
  }, n.eras = function(e) {
    var r = this;
    return Fe(this, e, Zr, function() {
      var a = {
        era: e
      };
      return r.eraCache[e] || (r.eraCache[e] = [D.utc(-40, 1, 1), D.utc(2017, 1, 1)].map(function(o) {
        return r.extract(o, a, "era");
      })), r.eraCache[e];
    });
  }, n.extract = function(e, r, a) {
    var o = this.dtFormatter(e, r), u = o.formatToParts(), s = u.find(function(l) {
      return l.type.toLowerCase() === a;
    });
    return s ? s.value : null;
  }, n.numberFormatter = function(e) {
    return e === void 0 && (e = {}), new Ln(this.intl, e.forceSimple || this.fastNumbers, e);
  }, n.dtFormatter = function(e, r) {
    return r === void 0 && (r = {}), new _n(e, this.intl, r);
  }, n.relFormatter = function(e) {
    return e === void 0 && (e = {}), new An(this.intl, this.isEnglish(), e);
  }, n.listFormatter = function(e) {
    return e === void 0 && (e = {}), Dn(this.intl, e);
  }, n.isEnglish = function() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }, n.getWeekSettings = function() {
    return this.weekSettings ? this.weekSettings : Er() ? En(this.locale) : Zn;
  }, n.getStartOfWeek = function() {
    return this.getWeekSettings().firstDay;
  }, n.getMinDaysInFirstWeek = function() {
    return this.getWeekSettings().minimalDays;
  }, n.getWeekendDays = function() {
    return this.getWeekSettings().weekend;
  }, n.equals = function(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }, n.toString = function() {
    return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
  }, U(t, [{
    key: "fastNumbers",
    get: function() {
      return this.fastNumbersCached == null && (this.fastNumbersCached = Wn(this)), this.fastNumbersCached;
    }
  }]), t;
}(), Ge = null, R = /* @__PURE__ */ function(t) {
  W(n, t), n.instance = function(r) {
    return r === 0 ? n.utcInstance : new n(r);
  }, n.parseSpecifier = function(r) {
    if (r) {
      var a = r.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (a)
        return new n(He(a[1], a[2]));
    }
    return null;
  };
  function n(e) {
    var r;
    return r = t.call(this) || this, r.fixed = e, r;
  }
  var i = n.prototype;
  return i.offsetName = function() {
    return this.name;
  }, i.formatOffset = function(r, a) {
    return ke(this.fixed, a);
  }, i.offset = function() {
    return this.fixed;
  }, i.equals = function(r) {
    return r.type === "fixed" && r.fixed === this.fixed;
  }, U(n, [{
    key: "type",
    get: function() {
      return "fixed";
    }
    /**
     * The name of this zone.
     * All fixed zones' names always start with "UTC" (plus optional offset)
     * @override
     * @type {string}
     */
  }, {
    key: "name",
    get: function() {
      return this.fixed === 0 ? "UTC" : "UTC" + ke(this.fixed, "narrow");
    }
    /**
     * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
     *
     * @override
     * @type {string}
     */
  }, {
    key: "ianaName",
    get: function() {
      return this.fixed === 0 ? "Etc/UTC" : "Etc/GMT" + ke(-this.fixed, "narrow");
    }
  }, {
    key: "isUniversal",
    get: function() {
      return !0;
    }
  }, {
    key: "isValid",
    get: function() {
      return !0;
    }
  }], [{
    key: "utcInstance",
    get: (
      /**
       * Get a singleton instance of UTC
       * @return {FixedOffsetZone}
       */
      function() {
        return Ge === null && (Ge = new n(0)), Ge;
      }
    )
  }]), n;
}(ue), Tr = /* @__PURE__ */ function(t) {
  W(n, t);
  function n(e) {
    var r;
    return r = t.call(this) || this, r.zoneName = e, r;
  }
  var i = n.prototype;
  return i.offsetName = function() {
    return null;
  }, i.formatOffset = function() {
    return "";
  }, i.offset = function() {
    return NaN;
  }, i.equals = function() {
    return !1;
  }, U(n, [{
    key: "type",
    get: function() {
      return "invalid";
    }
    /** @override **/
  }, {
    key: "name",
    get: function() {
      return this.zoneName;
    }
    /** @override **/
  }, {
    key: "isUniversal",
    get: function() {
      return !1;
    }
  }, {
    key: "isValid",
    get: function() {
      return !1;
    }
  }]), n;
}(ue);
function H(t, n) {
  if (g(t) || t === null)
    return n;
  if (t instanceof ue)
    return t;
  if ($n(t)) {
    var i = t.toLowerCase();
    return i === "default" ? n : i === "local" || i === "system" ? lt.instance : i === "utc" || i === "gmt" ? R.utcInstance : R.parseSpecifier(i) || Q.create(t);
  } else
    return Y(t) ? R.instance(t) : typeof t == "object" && "offset" in t && typeof t.offset == "function" ? t : new Tr(t);
}
var ft = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, It = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Rn = ft.hanidec.replace(/[\[|\]]/g, "").split("");
function zn(t) {
  var n = parseInt(t, 10);
  if (isNaN(n)) {
    n = "";
    for (var i = 0; i < t.length; i++) {
      var e = t.charCodeAt(i);
      if (t[i].search(ft.hanidec) !== -1)
        n += Rn.indexOf(t[i]);
      else
        for (var r in It) {
          var a = It[r], o = a[0], u = a[1];
          e >= o && e <= u && (n += e - o);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
var re = {};
function Un() {
  re = {};
}
function L(t, n) {
  var i = t.numberingSystem;
  n === void 0 && (n = "");
  var e = i || "latn";
  return re[e] || (re[e] = {}), re[e][n] || (re[e][n] = new RegExp("" + ft[e] + n)), re[e][n];
}
var Nt = function() {
  return Date.now();
}, Mt = "system", Et = null, Ft = null, xt = null, Ct = 60, Vt, Wt = null, p = /* @__PURE__ */ function() {
  function t() {
  }
  return t.resetCaches = function() {
    O.resetCache(), Q.resetCache(), D.resetCache(), Un();
  }, U(t, null, [{
    key: "now",
    get: (
      /**
       * Get the callback for returning the current timestamp.
       * @type {function}
       */
      function() {
        return Nt;
      }
    ),
    set: function(i) {
      Nt = i;
    }
    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * Use the value "system" to reset this value to the system's time zone.
     * @type {string}
     */
  }, {
    key: "defaultZone",
    get: (
      /**
       * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
       * The default value is the system's time zone (the one set on the machine that runs this code).
       * @type {Zone}
       */
      function() {
        return H(Mt, lt.instance);
      }
    ),
    set: function(i) {
      Mt = i;
    }
  }, {
    key: "defaultLocale",
    get: function() {
      return Et;
    },
    set: function(i) {
      Et = i;
    }
    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
  }, {
    key: "defaultNumberingSystem",
    get: function() {
      return Ft;
    },
    set: function(i) {
      Ft = i;
    }
    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
  }, {
    key: "defaultOutputCalendar",
    get: function() {
      return xt;
    },
    set: function(i) {
      xt = i;
    }
    /**
     * @typedef {Object} WeekSettings
     * @property {number} firstDay
     * @property {number} minimalDays
     * @property {number[]} weekend
     */
    /**
     * @return {WeekSettings|null}
     */
  }, {
    key: "defaultWeekSettings",
    get: function() {
      return Wt;
    },
    set: function(i) {
      Wt = ut(i);
    }
    /**
     * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
     * @type {number}
     */
  }, {
    key: "twoDigitCutoffYear",
    get: function() {
      return Ct;
    },
    set: function(i) {
      Ct = i % 100;
    }
    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
  }, {
    key: "throwOnInvalid",
    get: function() {
      return Vt;
    },
    set: function(i) {
      Vt = i;
    }
  }]), t;
}(), Z = /* @__PURE__ */ function() {
  function t(i, e) {
    this.reason = i, this.explanation = e;
  }
  var n = t.prototype;
  return n.toMessage = function() {
    return this.explanation ? this.reason + ": " + this.explanation : this.reason;
  }, t;
}(), Or = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], pr = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function x(t, n) {
  return new Z("unit out of range", "you specified " + n + " (of type " + typeof n + ") as a " + t + ", which is invalid");
}
function ct(t, n, i) {
  var e = new Date(Date.UTC(t, n - 1, i));
  t < 100 && t >= 0 && e.setUTCFullYear(e.getUTCFullYear() - 1900);
  var r = e.getUTCDay();
  return r === 0 ? 7 : r;
}
function br(t, n, i) {
  return i + (De(t) ? pr : Or)[n - 1];
}
function Dr(t, n) {
  var i = De(t) ? pr : Or, e = i.findIndex(function(a) {
    return a < n;
  }), r = n - i[e];
  return {
    month: e + 1,
    day: r
  };
}
function dt(t, n) {
  return (t - n + 7) % 7 + 1;
}
function ze(t, n, i) {
  n === void 0 && (n = 4), i === void 0 && (i = 1);
  var e = t.year, r = t.month, a = t.day, o = br(e, r, a), u = dt(ct(e, r, a), i), s = Math.floor((o - u + 14 - n) / 7), l;
  return s < 1 ? (l = e - 1, s = pe(l, n, i)) : s > pe(e, n, i) ? (l = e + 1, s = 1) : l = e, S({
    weekYear: l,
    weekNumber: s,
    weekday: u
  }, Ye(t));
}
function Lt(t, n, i) {
  n === void 0 && (n = 4), i === void 0 && (i = 1);
  var e = t.weekYear, r = t.weekNumber, a = t.weekday, o = dt(ct(e, 1, n), i), u = ie(e), s = r * 7 + a - o - 7 + n, l;
  s < 1 ? (l = e - 1, s += ie(l)) : s > u ? (l = e + 1, s -= ie(e)) : l = e;
  var f = Dr(l, s), c = f.month, d = f.day;
  return S({
    year: l,
    month: c,
    day: d
  }, Ye(t));
}
function Je(t) {
  var n = t.year, i = t.month, e = t.day, r = br(n, i, e);
  return S({
    year: n,
    ordinal: r
  }, Ye(t));
}
function _t(t) {
  var n = t.year, i = t.ordinal, e = Dr(n, i), r = e.month, a = e.day;
  return S({
    year: n,
    month: r,
    day: a
  }, Ye(t));
}
function At(t, n) {
  var i = !g(t.localWeekday) || !g(t.localWeekNumber) || !g(t.localWeekYear);
  if (i) {
    var e = !g(t.weekday) || !g(t.weekNumber) || !g(t.weekYear);
    if (e)
      throw new ne("Cannot mix locale-based week fields with ISO-based week fields");
    return g(t.localWeekday) || (t.weekday = t.localWeekday), g(t.localWeekNumber) || (t.weekNumber = t.localWeekNumber), g(t.localWeekYear) || (t.weekYear = t.localWeekYear), delete t.localWeekday, delete t.localWeekNumber, delete t.localWeekYear, {
      minDaysInFirstWeek: n.getMinDaysInFirstWeek(),
      startOfWeek: n.getStartOfWeek()
    };
  } else
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
}
function qn(t, n, i) {
  n === void 0 && (n = 4), i === void 0 && (i = 1);
  var e = Pe(t.weekYear), r = C(t.weekNumber, 1, pe(t.weekYear, n, i)), a = C(t.weekday, 1, 7);
  return e ? r ? a ? !1 : x("weekday", t.weekday) : x("week", t.weekNumber) : x("weekYear", t.weekYear);
}
function Pn(t) {
  var n = Pe(t.year), i = C(t.ordinal, 1, ie(t.year));
  return n ? i ? !1 : x("ordinal", t.ordinal) : x("year", t.year);
}
function Ir(t) {
  var n = Pe(t.year), i = C(t.month, 1, 12), e = C(t.day, 1, Ue(t.year, t.month));
  return n ? i ? e ? !1 : x("day", t.day) : x("month", t.month) : x("year", t.year);
}
function Nr(t) {
  var n = t.hour, i = t.minute, e = t.second, r = t.millisecond, a = C(n, 0, 23) || n === 24 && i === 0 && e === 0 && r === 0, o = C(i, 0, 59), u = C(e, 0, 59), s = C(r, 0, 999);
  return a ? o ? u ? s ? !1 : x("millisecond", r) : x("second", e) : x("minute", i) : x("hour", n);
}
function g(t) {
  return typeof t > "u";
}
function Y(t) {
  return typeof t == "number";
}
function Pe(t) {
  return typeof t == "number" && t % 1 === 0;
}
function $n(t) {
  return typeof t == "string";
}
function Hn(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function Mr() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Er() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function Yn(t) {
  return Array.isArray(t) ? t : [t];
}
function Zt(t, n, i) {
  if (t.length !== 0)
    return t.reduce(function(e, r) {
      var a = [n(r), r];
      return e && i(e[0], a[0]) === e[0] ? e : a;
    }, null)[1];
}
function jn(t, n) {
  return n.reduce(function(i, e) {
    return i[e] = t[e], i;
  }, {});
}
function oe(t, n) {
  return Object.prototype.hasOwnProperty.call(t, n);
}
function ut(t) {
  if (t == null)
    return null;
  if (typeof t != "object")
    throw new M("Week settings must be an object");
  if (!C(t.firstDay, 1, 7) || !C(t.minimalDays, 1, 7) || !Array.isArray(t.weekend) || t.weekend.some(function(n) {
    return !C(n, 1, 7);
  }))
    throw new M("Invalid week settings");
  return {
    firstDay: t.firstDay,
    minimalDays: t.minimalDays,
    weekend: Array.from(t.weekend)
  };
}
function C(t, n, i) {
  return Pe(t) && t >= n && t <= i;
}
function Gn(t, n) {
  return t - n * Math.floor(t / n);
}
function I(t, n) {
  n === void 0 && (n = 2);
  var i = t < 0, e;
  return i ? e = "-" + ("" + -t).padStart(n, "0") : e = ("" + t).padStart(n, "0"), e;
}
function $(t) {
  if (!(g(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function j(t) {
  if (!(g(t) || t === null || t === ""))
    return parseFloat(t);
}
function mt(t) {
  if (!(g(t) || t === null || t === "")) {
    var n = parseFloat("0." + t) * 1e3;
    return Math.floor(n);
  }
}
function ht(t, n, i) {
  i === void 0 && (i = !1);
  var e = Math.pow(10, n), r = i ? Math.trunc : Math.round;
  return r(t * e) / e;
}
function De(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function ie(t) {
  return De(t) ? 366 : 365;
}
function Ue(t, n) {
  var i = Gn(n - 1, 12) + 1, e = t + (n - i) / 12;
  return i === 2 ? De(e) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][i - 1];
}
function $e(t) {
  var n = Date.UTC(t.year, t.month - 1, t.day, t.hour, t.minute, t.second, t.millisecond);
  return t.year < 100 && t.year >= 0 && (n = new Date(n), n.setUTCFullYear(t.year, t.month - 1, t.day)), +n;
}
function Rt(t, n, i) {
  var e = dt(ct(t, 1, n), i);
  return -e + n - 1;
}
function pe(t, n, i) {
  n === void 0 && (n = 4), i === void 0 && (i = 1);
  var e = Rt(t, n, i), r = Rt(t + 1, n, i);
  return (ie(t) - e + r) / 7;
}
function st(t) {
  return t > 99 ? t : t > p.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function Fr(t, n, i, e) {
  e === void 0 && (e = null);
  var r = new Date(t), a = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  e && (a.timeZone = e);
  var o = S({
    timeZoneName: n
  }, a), u = new Intl.DateTimeFormat(i, o).formatToParts(r).find(function(s) {
    return s.type.toLowerCase() === "timezonename";
  });
  return u ? u.value : null;
}
function He(t, n) {
  var i = parseInt(t, 10);
  Number.isNaN(i) && (i = 0);
  var e = parseInt(n, 10) || 0, r = i < 0 || Object.is(i, -0) ? -e : e;
  return i * 60 + r;
}
function xr(t) {
  var n = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(n))
    throw new M("Invalid unit value " + t);
  return n;
}
function qe(t, n) {
  var i = {};
  for (var e in t)
    if (oe(t, e)) {
      var r = t[e];
      if (r == null)
        continue;
      i[n(e)] = xr(r);
    }
  return i;
}
function ke(t, n) {
  var i = Math.trunc(Math.abs(t / 60)), e = Math.trunc(Math.abs(t % 60)), r = t >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return "" + r + I(i, 2) + ":" + I(e, 2);
    case "narrow":
      return "" + r + i + (e > 0 ? ":" + e : "");
    case "techie":
      return "" + r + I(i, 2) + I(e, 2);
    default:
      throw new RangeError("Value format " + n + " is out of range for property format");
  }
}
function Ye(t) {
  return jn(t, ["hour", "minute", "second", "millisecond"]);
}
var Jn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], Cr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Bn = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Vr(t) {
  switch (t) {
    case "narrow":
      return [].concat(Bn);
    case "short":
      return [].concat(Cr);
    case "long":
      return [].concat(Jn);
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
var Wr = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], Lr = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], Qn = ["M", "T", "W", "T", "F", "S", "S"];
function _r(t) {
  switch (t) {
    case "narrow":
      return [].concat(Qn);
    case "short":
      return [].concat(Lr);
    case "long":
      return [].concat(Wr);
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
var Ar = ["AM", "PM"], Kn = ["Before Christ", "Anno Domini"], Xn = ["BC", "AD"], ei = ["B", "A"];
function Zr(t) {
  switch (t) {
    case "narrow":
      return [].concat(ei);
    case "short":
      return [].concat(Xn);
    case "long":
      return [].concat(Kn);
    default:
      return null;
  }
}
function ti(t) {
  return Ar[t.hour < 12 ? 0 : 1];
}
function ri(t, n) {
  return _r(n)[t.weekday - 1];
}
function ni(t, n) {
  return Vr(n)[t.month - 1];
}
function ii(t, n) {
  return Zr(n)[t.year < 0 ? 0 : 1];
}
function ai(t, n, i, e) {
  i === void 0 && (i = "always"), e === void 0 && (e = !1);
  var r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, a = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (i === "auto" && a) {
    var o = t === "days";
    switch (n) {
      case 1:
        return o ? "tomorrow" : "next " + r[t][0];
      case -1:
        return o ? "yesterday" : "last " + r[t][0];
      case 0:
        return o ? "today" : "this " + r[t][0];
    }
  }
  var u = Object.is(n, -0) || n < 0, s = Math.abs(n), l = s === 1, f = r[t], c = e ? l ? f[1] : f[2] || f[1] : l ? r[t][0] : t;
  return u ? s + " " + c + " ago" : "in " + s + " " + c;
}
function zt(t, n) {
  for (var i = "", e = be(t), r; !(r = e()).done; ) {
    var a = r.value;
    a.literal ? i += a.val : i += n(a.val);
  }
  return i;
}
var oi = {
  D: Re,
  DD: rr,
  DDD: nr,
  DDDD: ir,
  t: ar,
  tt: or,
  ttt: ur,
  tttt: sr,
  T: lr,
  TT: fr,
  TTT: cr,
  TTTT: dr,
  f: mr,
  ff: vr,
  fff: gr,
  ffff: Sr,
  F: hr,
  FF: yr,
  FFF: wr,
  FFFF: kr
}, A = /* @__PURE__ */ function() {
  t.create = function(e, r) {
    return r === void 0 && (r = {}), new t(e, r);
  }, t.parseFormat = function(e) {
    for (var r = null, a = "", o = !1, u = [], s = 0; s < e.length; s++) {
      var l = e.charAt(s);
      l === "'" ? (a.length > 0 && u.push({
        literal: o || /^\s+$/.test(a),
        val: a
      }), r = null, a = "", o = !o) : o || l === r ? a += l : (a.length > 0 && u.push({
        literal: /^\s+$/.test(a),
        val: a
      }), a = l, r = l);
    }
    return a.length > 0 && u.push({
      literal: o || /^\s+$/.test(a),
      val: a
    }), u;
  }, t.macroTokenToFormatOpts = function(e) {
    return oi[e];
  };
  function t(i, e) {
    this.opts = e, this.loc = i, this.systemLoc = null;
  }
  var n = t.prototype;
  return n.formatWithSystemDefault = function(e, r) {
    this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem());
    var a = this.systemLoc.dtFormatter(e, S({}, this.opts, r));
    return a.format();
  }, n.dtFormatter = function(e, r) {
    return r === void 0 && (r = {}), this.loc.dtFormatter(e, S({}, this.opts, r));
  }, n.formatDateTime = function(e, r) {
    return this.dtFormatter(e, r).format();
  }, n.formatDateTimeParts = function(e, r) {
    return this.dtFormatter(e, r).formatToParts();
  }, n.formatInterval = function(e, r) {
    var a = this.dtFormatter(e.start, r);
    return a.dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }, n.resolvedOptions = function(e, r) {
    return this.dtFormatter(e, r).resolvedOptions();
  }, n.num = function(e, r) {
    if (r === void 0 && (r = 0), this.opts.forceSimple)
      return I(e, r);
    var a = S({}, this.opts);
    return r > 0 && (a.padTo = r), this.loc.numberFormatter(a).format(e);
  }, n.formatDateTimeFromString = function(e, r) {
    var a = this, o = this.loc.listingMode() === "en", u = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", s = function(y, b) {
      return a.loc.extract(e, y, b);
    }, l = function(y) {
      return e.isOffsetFixed && e.offset === 0 && y.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, y.format) : "";
    }, f = function() {
      return o ? ti(e) : s({
        hour: "numeric",
        hourCycle: "h12"
      }, "dayperiod");
    }, c = function(y, b) {
      return o ? ni(e, y) : s(b ? {
        month: y
      } : {
        month: y,
        day: "numeric"
      }, "month");
    }, d = function(y, b) {
      return o ? ri(e, y) : s(b ? {
        weekday: y
      } : {
        weekday: y,
        month: "long",
        day: "numeric"
      }, "weekday");
    }, m = function(y) {
      var b = t.macroTokenToFormatOpts(y);
      return b ? a.formatWithSystemDefault(e, b) : y;
    }, v = function(y) {
      return o ? ii(e, y) : s({
        era: y
      }, "era");
    }, w = function(y) {
      switch (y) {
        case "S":
          return a.num(e.millisecond);
        case "u":
        case "SSS":
          return a.num(e.millisecond, 3);
        case "s":
          return a.num(e.second);
        case "ss":
          return a.num(e.second, 2);
        case "uu":
          return a.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return a.num(Math.floor(e.millisecond / 100));
        case "m":
          return a.num(e.minute);
        case "mm":
          return a.num(e.minute, 2);
        case "h":
          return a.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return a.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return a.num(e.hour);
        case "HH":
          return a.num(e.hour, 2);
        case "Z":
          return l({
            format: "narrow",
            allowZ: a.opts.allowZ
          });
        case "ZZ":
          return l({
            format: "short",
            allowZ: a.opts.allowZ
          });
        case "ZZZ":
          return l({
            format: "techie",
            allowZ: a.opts.allowZ
          });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, {
            format: "short",
            locale: a.loc.locale
          });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, {
            format: "long",
            locale: a.loc.locale
          });
        case "z":
          return e.zoneName;
        case "a":
          return f();
        case "d":
          return u ? s({
            day: "numeric"
          }, "day") : a.num(e.day);
        case "dd":
          return u ? s({
            day: "2-digit"
          }, "day") : a.num(e.day, 2);
        case "c":
          return a.num(e.weekday);
        case "ccc":
          return d("short", !0);
        case "cccc":
          return d("long", !0);
        case "ccccc":
          return d("narrow", !0);
        case "E":
          return a.num(e.weekday);
        case "EEE":
          return d("short", !1);
        case "EEEE":
          return d("long", !1);
        case "EEEEE":
          return d("narrow", !1);
        case "L":
          return u ? s({
            month: "numeric",
            day: "numeric"
          }, "month") : a.num(e.month);
        case "LL":
          return u ? s({
            month: "2-digit",
            day: "numeric"
          }, "month") : a.num(e.month, 2);
        case "LLL":
          return c("short", !0);
        case "LLLL":
          return c("long", !0);
        case "LLLLL":
          return c("narrow", !0);
        case "M":
          return u ? s({
            month: "numeric"
          }, "month") : a.num(e.month);
        case "MM":
          return u ? s({
            month: "2-digit"
          }, "month") : a.num(e.month, 2);
        case "MMM":
          return c("short", !1);
        case "MMMM":
          return c("long", !1);
        case "MMMMM":
          return c("narrow", !1);
        case "y":
          return u ? s({
            year: "numeric"
          }, "year") : a.num(e.year);
        case "yy":
          return u ? s({
            year: "2-digit"
          }, "year") : a.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return u ? s({
            year: "numeric"
          }, "year") : a.num(e.year, 4);
        case "yyyyyy":
          return u ? s({
            year: "numeric"
          }, "year") : a.num(e.year, 6);
        case "G":
          return v("short");
        case "GG":
          return v("long");
        case "GGGGG":
          return v("narrow");
        case "kk":
          return a.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return a.num(e.weekYear, 4);
        case "W":
          return a.num(e.weekNumber);
        case "WW":
          return a.num(e.weekNumber, 2);
        case "n":
          return a.num(e.localWeekNumber);
        case "nn":
          return a.num(e.localWeekNumber, 2);
        case "ii":
          return a.num(e.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return a.num(e.localWeekYear, 4);
        case "o":
          return a.num(e.ordinal);
        case "ooo":
          return a.num(e.ordinal, 3);
        case "q":
          return a.num(e.quarter);
        case "qq":
          return a.num(e.quarter, 2);
        case "X":
          return a.num(Math.floor(e.ts / 1e3));
        case "x":
          return a.num(e.ts);
        default:
          return m(y);
      }
    };
    return zt(t.parseFormat(r), w);
  }, n.formatDurationFromString = function(e, r) {
    var a = this, o = function(d) {
      switch (d[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, u = function(d) {
      return function(m) {
        var v = o(m);
        return v ? a.num(d.get(v), m.length) : m;
      };
    }, s = t.parseFormat(r), l = s.reduce(function(c, d) {
      var m = d.literal, v = d.val;
      return m ? c : c.concat(v);
    }, []), f = e.shiftTo.apply(e, l.map(o).filter(function(c) {
      return c;
    }));
    return zt(s, u(f));
  }, t;
}(), Rr = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function se() {
  for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++)
    n[i] = arguments[i];
  var e = n.reduce(function(r, a) {
    return r + a.source;
  }, "");
  return RegExp("^" + e + "$");
}
function le() {
  for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++)
    n[i] = arguments[i];
  return function(e) {
    return n.reduce(function(r, a) {
      var o = r[0], u = r[1], s = r[2], l = a(e, s), f = l[0], c = l[1], d = l[2];
      return [S({}, o, f), c || u, d];
    }, [{}, null, 1]).slice(0, 2);
  };
}
function fe(t) {
  if (t == null)
    return [null, null];
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), e = 1; e < n; e++)
    i[e - 1] = arguments[e];
  for (var r = 0, a = i; r < a.length; r++) {
    var o = a[r], u = o[0], s = o[1], l = u.exec(t);
    if (l)
      return s(l);
  }
  return [null, null];
}
function zr() {
  for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++)
    n[i] = arguments[i];
  return function(e, r) {
    var a = {}, o;
    for (o = 0; o < n.length; o++)
      a[n[o]] = $(e[r + o]);
    return [a, null, r + o];
  };
}
var Ur = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, ui = "(?:" + Ur.source + "?(?:\\[(" + Rr.source + ")\\])?)?", vt = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, qr = RegExp("" + vt.source + ui), yt = RegExp("(?:T" + qr.source + ")?"), si = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, li = /(\d{4})-?W(\d\d)(?:-?(\d))?/, fi = /(\d{4})-?(\d{3})/, ci = zr("weekYear", "weekNumber", "weekDay"), di = zr("year", "ordinal"), mi = /(\d{4})-(\d\d)-(\d\d)/, Pr = RegExp(vt.source + " ?(?:" + Ur.source + "|(" + Rr.source + "))?"), hi = RegExp("(?: " + Pr.source + ")?");
function ae(t, n, i) {
  var e = t[n];
  return g(e) ? i : $(e);
}
function vi(t, n) {
  var i = {
    year: ae(t, n),
    month: ae(t, n + 1, 1),
    day: ae(t, n + 2, 1)
  };
  return [i, null, n + 3];
}
function ce(t, n) {
  var i = {
    hours: ae(t, n, 0),
    minutes: ae(t, n + 1, 0),
    seconds: ae(t, n + 2, 0),
    milliseconds: mt(t[n + 3])
  };
  return [i, null, n + 4];
}
function Ie(t, n) {
  var i = !t[n] && !t[n + 1], e = He(t[n + 1], t[n + 2]), r = i ? null : R.instance(e);
  return [{}, r, n + 3];
}
function Ne(t, n) {
  var i = t[n] ? Q.create(t[n]) : null;
  return [{}, i, n + 1];
}
var yi = RegExp("^T?" + vt.source + "$"), gi = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function wi(t) {
  var n = t[0], i = t[1], e = t[2], r = t[3], a = t[4], o = t[5], u = t[6], s = t[7], l = t[8], f = n[0] === "-", c = s && s[0] === "-", d = function(v, w) {
    return w === void 0 && (w = !1), v !== void 0 && (w || v && f) ? -v : v;
  };
  return [{
    years: d(j(i)),
    months: d(j(e)),
    weeks: d(j(r)),
    days: d(j(a)),
    hours: d(j(o)),
    minutes: d(j(u)),
    seconds: d(j(s), s === "-0"),
    milliseconds: d(mt(l), c)
  }];
}
var Si = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function gt(t, n, i, e, r, a, o) {
  var u = {
    year: n.length === 2 ? st($(n)) : $(n),
    month: Cr.indexOf(i) + 1,
    day: $(e),
    hour: $(r),
    minute: $(a)
  };
  return o && (u.second = $(o)), t && (u.weekday = t.length > 3 ? Wr.indexOf(t) + 1 : Lr.indexOf(t) + 1), u;
}
var ki = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Ti(t) {
  var n = t[1], i = t[2], e = t[3], r = t[4], a = t[5], o = t[6], u = t[7], s = t[8], l = t[9], f = t[10], c = t[11], d = gt(n, r, e, i, a, o, u), m;
  return s ? m = Si[s] : l ? m = 0 : m = He(f, c), [d, new R(m)];
}
function Oi(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
var pi = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, bi = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Di = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Ut(t) {
  var n = t[1], i = t[2], e = t[3], r = t[4], a = t[5], o = t[6], u = t[7], s = gt(n, r, e, i, a, o, u);
  return [s, R.utcInstance];
}
function Ii(t) {
  var n = t[1], i = t[2], e = t[3], r = t[4], a = t[5], o = t[6], u = t[7], s = gt(n, u, i, e, r, a, o);
  return [s, R.utcInstance];
}
var Ni = se(si, yt), Mi = se(li, yt), Ei = se(fi, yt), Fi = se(qr), $r = le(vi, ce, Ie, Ne), xi = le(ci, ce, Ie, Ne), Ci = le(di, ce, Ie, Ne), Vi = le(ce, Ie, Ne);
function Wi(t) {
  return fe(t, [Ni, $r], [Mi, xi], [Ei, Ci], [Fi, Vi]);
}
function Li(t) {
  return fe(Oi(t), [ki, Ti]);
}
function _i(t) {
  return fe(t, [pi, Ut], [bi, Ut], [Di, Ii]);
}
function Ai(t) {
  return fe(t, [gi, wi]);
}
var Zi = le(ce);
function Ri(t) {
  return fe(t, [yi, Zi]);
}
var zi = se(mi, hi), Ui = se(Pr), qi = le(ce, Ie, Ne);
function Pi(t) {
  return fe(t, [zi, $r], [Ui, qi]);
}
var qt = "Invalid Duration", Hr = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1e3
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1e3
  },
  seconds: {
    milliseconds: 1e3
  }
}, $i = S({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  }
}, Hr), F = 146097 / 400, X = 146097 / 4800, Hi = S({
  years: {
    quarters: 4,
    months: 12,
    weeks: F / 7,
    days: F,
    hours: F * 24,
    minutes: F * 24 * 60,
    seconds: F * 24 * 60 * 60,
    milliseconds: F * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: F / 28,
    days: F / 4,
    hours: F * 24 / 4,
    minutes: F * 24 * 60 / 4,
    seconds: F * 24 * 60 * 60 / 4,
    milliseconds: F * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: X / 7,
    days: X,
    hours: X * 24,
    minutes: X * 24 * 60,
    seconds: X * 24 * 60 * 60,
    milliseconds: X * 24 * 60 * 60 * 1e3
  }
}, Hr), J = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"], Yi = J.slice(0).reverse();
function P(t, n, i) {
  i === void 0 && (i = !1);
  var e = {
    values: i ? n.values : S({}, t.values, n.values || {}),
    loc: t.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || t.conversionAccuracy,
    matrix: n.matrix || t.matrix
  };
  return new N(e);
}
function Yr(t, n) {
  for (var i, e = (i = n.milliseconds) != null ? i : 0, r = be(Yi.slice(1)), a; !(a = r()).done; ) {
    var o = a.value;
    n[o] && (e += n[o] * t[o].milliseconds);
  }
  return e;
}
function Pt(t, n) {
  var i = Yr(t, n) < 0 ? -1 : 1;
  J.reduceRight(function(e, r) {
    if (g(n[r]))
      return e;
    if (e) {
      var a = n[e] * i, o = t[r][e], u = Math.floor(a / o);
      n[r] += u * i, n[e] -= u * o * i;
    }
    return r;
  }, null), J.reduce(function(e, r) {
    if (g(n[r]))
      return e;
    if (e) {
      var a = n[e] % 1;
      n[e] -= a, n[r] += a * t[e][r];
    }
    return r;
  }, null);
}
function ji(t) {
  for (var n = {}, i = 0, e = Object.entries(t); i < e.length; i++) {
    var r = e[i], a = r[0], o = r[1];
    o !== 0 && (n[a] = o);
  }
  return n;
}
var N = /* @__PURE__ */ function(t) {
  function n(e) {
    var r = e.conversionAccuracy === "longterm" || !1, a = r ? Hi : $i;
    e.matrix && (a = e.matrix), this.values = e.values, this.loc = e.loc || O.create(), this.conversionAccuracy = r ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = a, this.isLuxonDuration = !0;
  }
  n.fromMillis = function(r, a) {
    return n.fromObject({
      milliseconds: r
    }, a);
  }, n.fromObject = function(r, a) {
    if (a === void 0 && (a = {}), r == null || typeof r != "object")
      throw new M("Duration.fromObject: argument expected to be an object, got " + (r === null ? "null" : typeof r));
    return new n({
      values: qe(r, n.normalizeUnit),
      loc: O.fromObject(a),
      conversionAccuracy: a.conversionAccuracy,
      matrix: a.matrix
    });
  }, n.fromDurationLike = function(r) {
    if (Y(r))
      return n.fromMillis(r);
    if (n.isDuration(r))
      return r;
    if (typeof r == "object")
      return n.fromObject(r);
    throw new M("Unknown duration argument " + r + " of type " + typeof r);
  }, n.fromISO = function(r, a) {
    var o = Ai(r), u = o[0];
    return u ? n.fromObject(u, a) : n.invalid("unparsable", 'the input "' + r + `" can't be parsed as ISO 8601`);
  }, n.fromISOTime = function(r, a) {
    var o = Ri(r), u = o[0];
    return u ? n.fromObject(u, a) : n.invalid("unparsable", 'the input "' + r + `" can't be parsed as ISO 8601`);
  }, n.invalid = function(r, a) {
    if (a === void 0 && (a = null), !r)
      throw new M("need to specify a reason the Duration is invalid");
    var o = r instanceof Z ? r : new Z(r, a);
    if (p.throwOnInvalid)
      throw new yn(o);
    return new n({
      invalid: o
    });
  }, n.normalizeUnit = function(r) {
    var a = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[r && r.toLowerCase()];
    if (!a)
      throw new tr(r);
    return a;
  }, n.isDuration = function(r) {
    return r && r.isLuxonDuration || !1;
  };
  var i = n.prototype;
  return i.toFormat = function(r, a) {
    a === void 0 && (a = {});
    var o = S({}, a, {
      floor: a.round !== !1 && a.floor !== !1
    });
    return this.isValid ? A.create(this.loc, o).formatDurationFromString(this, r) : qt;
  }, i.toHuman = function(r) {
    var a = this;
    if (r === void 0 && (r = {}), !this.isValid)
      return qt;
    var o = J.map(function(u) {
      var s = a.values[u];
      return g(s) ? null : a.loc.numberFormatter(S({
        style: "unit",
        unitDisplay: "long"
      }, r, {
        unit: u.slice(0, -1)
      })).format(s);
    }).filter(function(u) {
      return u;
    });
    return this.loc.listFormatter(S({
      type: "conjunction",
      style: r.listStyle || "narrow"
    }, r)).format(o);
  }, i.toObject = function() {
    return this.isValid ? S({}, this.values) : {};
  }, i.toISO = function() {
    if (!this.isValid)
      return null;
    var r = "P";
    return this.years !== 0 && (r += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (r += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (r += this.weeks + "W"), this.days !== 0 && (r += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (r += "T"), this.hours !== 0 && (r += this.hours + "H"), this.minutes !== 0 && (r += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (r += ht(this.seconds + this.milliseconds / 1e3, 3) + "S"), r === "P" && (r += "T0S"), r;
  }, i.toISOTime = function(r) {
    if (r === void 0 && (r = {}), !this.isValid)
      return null;
    var a = this.toMillis();
    if (a < 0 || a >= 864e5)
      return null;
    r = S({
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended"
    }, r, {
      includeOffset: !1
    });
    var o = D.fromMillis(a, {
      zone: "UTC"
    });
    return o.toISOTime(r);
  }, i.toJSON = function() {
    return this.toISO();
  }, i.toString = function() {
    return this.toISO();
  }, i[t] = function() {
    return this.isValid ? "Duration { values: " + JSON.stringify(this.values) + " }" : "Duration { Invalid, reason: " + this.invalidReason + " }";
  }, i.toMillis = function() {
    return this.isValid ? Yr(this.matrix, this.values) : NaN;
  }, i.valueOf = function() {
    return this.toMillis();
  }, i.plus = function(r) {
    if (!this.isValid)
      return this;
    for (var a = n.fromDurationLike(r), o = {}, u = 0, s = J; u < s.length; u++) {
      var l = s[u];
      (oe(a.values, l) || oe(this.values, l)) && (o[l] = a.get(l) + this.get(l));
    }
    return P(this, {
      values: o
    }, !0);
  }, i.minus = function(r) {
    if (!this.isValid)
      return this;
    var a = n.fromDurationLike(r);
    return this.plus(a.negate());
  }, i.mapUnits = function(r) {
    if (!this.isValid)
      return this;
    for (var a = {}, o = 0, u = Object.keys(this.values); o < u.length; o++) {
      var s = u[o];
      a[s] = xr(r(this.values[s], s));
    }
    return P(this, {
      values: a
    }, !0);
  }, i.get = function(r) {
    return this[n.normalizeUnit(r)];
  }, i.set = function(r) {
    if (!this.isValid)
      return this;
    var a = S({}, this.values, qe(r, n.normalizeUnit));
    return P(this, {
      values: a
    });
  }, i.reconfigure = function(r) {
    var a = r === void 0 ? {} : r, o = a.locale, u = a.numberingSystem, s = a.conversionAccuracy, l = a.matrix, f = this.loc.clone({
      locale: o,
      numberingSystem: u
    }), c = {
      loc: f,
      matrix: l,
      conversionAccuracy: s
    };
    return P(this, c);
  }, i.as = function(r) {
    return this.isValid ? this.shiftTo(r).get(r) : NaN;
  }, i.normalize = function() {
    if (!this.isValid)
      return this;
    var r = this.toObject();
    return Pt(this.matrix, r), P(this, {
      values: r
    }, !0);
  }, i.rescale = function() {
    if (!this.isValid)
      return this;
    var r = ji(this.normalize().shiftToAll().toObject());
    return P(this, {
      values: r
    }, !0);
  }, i.shiftTo = function() {
    for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
      a[o] = arguments[o];
    if (!this.isValid)
      return this;
    if (a.length === 0)
      return this;
    a = a.map(function(b) {
      return n.normalizeUnit(b);
    });
    for (var u = {}, s = {}, l = this.toObject(), f, c = 0, d = J; c < d.length; c++) {
      var m = d[c];
      if (a.indexOf(m) >= 0) {
        f = m;
        var v = 0;
        for (var w in s)
          v += this.matrix[w][m] * s[w], s[w] = 0;
        Y(l[m]) && (v += l[m]);
        var k = Math.trunc(v);
        u[m] = k, s[m] = (v * 1e3 - k * 1e3) / 1e3;
      } else
        Y(l[m]) && (s[m] = l[m]);
    }
    for (var y in s)
      s[y] !== 0 && (u[f] += y === f ? s[y] : s[y] / this.matrix[f][y]);
    return Pt(this.matrix, u), P(this, {
      values: u
    }, !0);
  }, i.shiftToAll = function() {
    return this.isValid ? this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds") : this;
  }, i.negate = function() {
    if (!this.isValid)
      return this;
    for (var r = {}, a = 0, o = Object.keys(this.values); a < o.length; a++) {
      var u = o[a];
      r[u] = this.values[u] === 0 ? 0 : -this.values[u];
    }
    return P(this, {
      values: r
    }, !0);
  }, i.equals = function(r) {
    if (!this.isValid || !r.isValid || !this.loc.equals(r.loc))
      return !1;
    function a(l, f) {
      return l === void 0 || l === 0 ? f === void 0 || f === 0 : l === f;
    }
    for (var o = 0, u = J; o < u.length; o++) {
      var s = u[o];
      if (!a(this.values[s], r.values[s]))
        return !1;
    }
    return !0;
  }, U(n, [{
    key: "locale",
    get: function() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */
  }, {
    key: "numberingSystem",
    get: function() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
  }, {
    key: "years",
    get: function() {
      return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
     * Get the quarters.
     * @type {number}
     */
  }, {
    key: "quarters",
    get: function() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
     * Get the months.
     * @type {number}
     */
  }, {
    key: "months",
    get: function() {
      return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
     * Get the weeks
     * @type {number}
     */
  }, {
    key: "weeks",
    get: function() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
     * Get the days.
     * @type {number}
     */
  }, {
    key: "days",
    get: function() {
      return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
     * Get the hours.
     * @type {number}
     */
  }, {
    key: "hours",
    get: function() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
     * Get the minutes.
     * @type {number}
     */
  }, {
    key: "minutes",
    get: function() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
     * Get the seconds.
     * @return {number}
     */
  }, {
    key: "seconds",
    get: function() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
     * Get the milliseconds.
     * @return {number}
     */
  }, {
    key: "milliseconds",
    get: function() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    get: function() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */
  }, {
    key: "invalidReason",
    get: function() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]), n;
}(Symbol.for("nodejs.util.inspect.custom")), ee = "Invalid Interval";
function Gi(t, n) {
  return !t || !t.isValid ? Te.invalid("missing or invalid start") : !n || !n.isValid ? Te.invalid("missing or invalid end") : n < t ? Te.invalid("end before start", "The end of an interval must be after its start, but you had start=" + t.toISO() + " and end=" + n.toISO()) : null;
}
var Te = /* @__PURE__ */ function(t) {
  function n(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  n.invalid = function(r, a) {
    if (a === void 0 && (a = null), !r)
      throw new M("need to specify a reason the Interval is invalid");
    var o = r instanceof Z ? r : new Z(r, a);
    if (p.throwOnInvalid)
      throw new vn(o);
    return new n({
      invalid: o
    });
  }, n.fromDateTimes = function(r, a) {
    var o = ye(r), u = ye(a), s = Gi(o, u);
    return s ?? new n({
      start: o,
      end: u
    });
  }, n.after = function(r, a) {
    var o = N.fromDurationLike(a), u = ye(r);
    return n.fromDateTimes(u, u.plus(o));
  }, n.before = function(r, a) {
    var o = N.fromDurationLike(a), u = ye(r);
    return n.fromDateTimes(u.minus(o), u);
  }, n.fromISO = function(r, a) {
    var o = (r || "").split("/", 2), u = o[0], s = o[1];
    if (u && s) {
      var l, f;
      try {
        l = D.fromISO(u, a), f = l.isValid;
      } catch {
        f = !1;
      }
      var c, d;
      try {
        c = D.fromISO(s, a), d = c.isValid;
      } catch {
        d = !1;
      }
      if (f && d)
        return n.fromDateTimes(l, c);
      if (f) {
        var m = N.fromISO(s, a);
        if (m.isValid)
          return n.after(l, m);
      } else if (d) {
        var v = N.fromISO(u, a);
        if (v.isValid)
          return n.before(c, v);
      }
    }
    return n.invalid("unparsable", 'the input "' + r + `" can't be parsed as ISO 8601`);
  }, n.isInterval = function(r) {
    return r && r.isLuxonInterval || !1;
  };
  var i = n.prototype;
  return i.length = function(r) {
    return r === void 0 && (r = "milliseconds"), this.isValid ? this.toDuration.apply(this, [r]).get(r) : NaN;
  }, i.count = function(r, a) {
    if (r === void 0 && (r = "milliseconds"), !this.isValid)
      return NaN;
    var o = this.start.startOf(r, a), u;
    return a != null && a.useLocaleWeeks ? u = this.end.reconfigure({
      locale: o.locale
    }) : u = this.end, u = u.startOf(r, a), Math.floor(u.diff(o, r).get(r)) + (u.valueOf() !== this.end.valueOf());
  }, i.hasSame = function(r) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, r) : !1;
  }, i.isEmpty = function() {
    return this.s.valueOf() === this.e.valueOf();
  }, i.isAfter = function(r) {
    return this.isValid ? this.s > r : !1;
  }, i.isBefore = function(r) {
    return this.isValid ? this.e <= r : !1;
  }, i.contains = function(r) {
    return this.isValid ? this.s <= r && this.e > r : !1;
  }, i.set = function(r) {
    var a = r === void 0 ? {} : r, o = a.start, u = a.end;
    return this.isValid ? n.fromDateTimes(o || this.s, u || this.e) : this;
  }, i.splitAt = function() {
    var r = this;
    if (!this.isValid)
      return [];
    for (var a = arguments.length, o = new Array(a), u = 0; u < a; u++)
      o[u] = arguments[u];
    for (var s = o.map(ye).filter(function(v) {
      return r.contains(v);
    }).sort(function(v, w) {
      return v.toMillis() - w.toMillis();
    }), l = [], f = this.s, c = 0; f < this.e; ) {
      var d = s[c] || this.e, m = +d > +this.e ? this.e : d;
      l.push(n.fromDateTimes(f, m)), f = m, c += 1;
    }
    return l;
  }, i.splitBy = function(r) {
    var a = N.fromDurationLike(r);
    if (!this.isValid || !a.isValid || a.as("milliseconds") === 0)
      return [];
    for (var o = this.s, u = 1, s, l = []; o < this.e; ) {
      var f = this.start.plus(a.mapUnits(function(c) {
        return c * u;
      }));
      s = +f > +this.e ? this.e : f, l.push(n.fromDateTimes(o, s)), o = s, u += 1;
    }
    return l;
  }, i.divideEqually = function(r) {
    return this.isValid ? this.splitBy(this.length() / r).slice(0, r) : [];
  }, i.overlaps = function(r) {
    return this.e > r.s && this.s < r.e;
  }, i.abutsStart = function(r) {
    return this.isValid ? +this.e == +r.s : !1;
  }, i.abutsEnd = function(r) {
    return this.isValid ? +r.e == +this.s : !1;
  }, i.engulfs = function(r) {
    return this.isValid ? this.s <= r.s && this.e >= r.e : !1;
  }, i.equals = function(r) {
    return !this.isValid || !r.isValid ? !1 : this.s.equals(r.s) && this.e.equals(r.e);
  }, i.intersection = function(r) {
    if (!this.isValid)
      return this;
    var a = this.s > r.s ? this.s : r.s, o = this.e < r.e ? this.e : r.e;
    return a >= o ? null : n.fromDateTimes(a, o);
  }, i.union = function(r) {
    if (!this.isValid)
      return this;
    var a = this.s < r.s ? this.s : r.s, o = this.e > r.e ? this.e : r.e;
    return n.fromDateTimes(a, o);
  }, n.merge = function(r) {
    var a = r.sort(function(s, l) {
      return s.s - l.s;
    }).reduce(function(s, l) {
      var f = s[0], c = s[1];
      return c ? c.overlaps(l) || c.abutsStart(l) ? [f, c.union(l)] : [f.concat([c]), l] : [f, l];
    }, [[], null]), o = a[0], u = a[1];
    return u && o.push(u), o;
  }, n.xor = function(r) {
    for (var a, o = null, u = 0, s = [], l = r.map(function(w) {
      return [{
        time: w.s,
        type: "s"
      }, {
        time: w.e,
        type: "e"
      }];
    }), f = (a = Array.prototype).concat.apply(a, l), c = f.sort(function(w, k) {
      return w.time - k.time;
    }), d = be(c), m; !(m = d()).done; ) {
      var v = m.value;
      u += v.type === "s" ? 1 : -1, u === 1 ? o = v.time : (o && +o != +v.time && s.push(n.fromDateTimes(o, v.time)), o = null);
    }
    return n.merge(s);
  }, i.difference = function() {
    for (var r = this, a = arguments.length, o = new Array(a), u = 0; u < a; u++)
      o[u] = arguments[u];
    return n.xor([this].concat(o)).map(function(s) {
      return r.intersection(s);
    }).filter(function(s) {
      return s && !s.isEmpty();
    });
  }, i.toString = function() {
    return this.isValid ? "[" + this.s.toISO() + " – " + this.e.toISO() + ")" : ee;
  }, i[t] = function() {
    return this.isValid ? "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }" : "Interval { Invalid, reason: " + this.invalidReason + " }";
  }, i.toLocaleString = function(r, a) {
    return r === void 0 && (r = Re), a === void 0 && (a = {}), this.isValid ? A.create(this.s.loc.clone(a), r).formatInterval(this) : ee;
  }, i.toISO = function(r) {
    return this.isValid ? this.s.toISO(r) + "/" + this.e.toISO(r) : ee;
  }, i.toISODate = function() {
    return this.isValid ? this.s.toISODate() + "/" + this.e.toISODate() : ee;
  }, i.toISOTime = function(r) {
    return this.isValid ? this.s.toISOTime(r) + "/" + this.e.toISOTime(r) : ee;
  }, i.toFormat = function(r, a) {
    var o = a === void 0 ? {} : a, u = o.separator, s = u === void 0 ? " – " : u;
    return this.isValid ? "" + this.s.toFormat(r) + s + this.e.toFormat(r) : ee;
  }, i.toDuration = function(r, a) {
    return this.isValid ? this.e.diff(this.s, r, a) : N.invalid(this.invalidReason);
  }, i.mapEndpoints = function(r) {
    return n.fromDateTimes(r(this.s), r(this.e));
  }, U(n, [{
    key: "start",
    get: function() {
      return this.isValid ? this.s : null;
    }
    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */
  }, {
    key: "end",
    get: function() {
      return this.isValid ? this.e : null;
    }
    /**
     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
     * @type {boolean}
     */
  }, {
    key: "isValid",
    get: function() {
      return this.invalidReason === null;
    }
    /**
     * Returns an error code if this Interval is invalid, or null if the Interval is valid
     * @type {string}
     */
  }, {
    key: "invalidReason",
    get: function() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]), n;
}(Symbol.for("nodejs.util.inspect.custom")), we = /* @__PURE__ */ function() {
  function t() {
  }
  return t.hasDST = function(i) {
    i === void 0 && (i = p.defaultZone);
    var e = D.now().setZone(i).set({
      month: 12
    });
    return !i.isUniversal && e.offset !== e.set({
      month: 6
    }).offset;
  }, t.isValidIANAZone = function(i) {
    return Q.isValidZone(i);
  }, t.normalizeZone = function(i) {
    return H(i, p.defaultZone);
  }, t.getStartOfWeek = function(i) {
    var e = i === void 0 ? {} : i, r = e.locale, a = r === void 0 ? null : r, o = e.locObj, u = o === void 0 ? null : o;
    return (u || O.create(a)).getStartOfWeek();
  }, t.getMinimumDaysInFirstWeek = function(i) {
    var e = i === void 0 ? {} : i, r = e.locale, a = r === void 0 ? null : r, o = e.locObj, u = o === void 0 ? null : o;
    return (u || O.create(a)).getMinDaysInFirstWeek();
  }, t.getWeekendWeekdays = function(i) {
    var e = i === void 0 ? {} : i, r = e.locale, a = r === void 0 ? null : r, o = e.locObj, u = o === void 0 ? null : o;
    return (u || O.create(a)).getWeekendDays().slice();
  }, t.months = function(i, e) {
    i === void 0 && (i = "long");
    var r = e === void 0 ? {} : e, a = r.locale, o = a === void 0 ? null : a, u = r.numberingSystem, s = u === void 0 ? null : u, l = r.locObj, f = l === void 0 ? null : l, c = r.outputCalendar, d = c === void 0 ? "gregory" : c;
    return (f || O.create(o, s, d)).months(i);
  }, t.monthsFormat = function(i, e) {
    i === void 0 && (i = "long");
    var r = e === void 0 ? {} : e, a = r.locale, o = a === void 0 ? null : a, u = r.numberingSystem, s = u === void 0 ? null : u, l = r.locObj, f = l === void 0 ? null : l, c = r.outputCalendar, d = c === void 0 ? "gregory" : c;
    return (f || O.create(o, s, d)).months(i, !0);
  }, t.weekdays = function(i, e) {
    i === void 0 && (i = "long");
    var r = e === void 0 ? {} : e, a = r.locale, o = a === void 0 ? null : a, u = r.numberingSystem, s = u === void 0 ? null : u, l = r.locObj, f = l === void 0 ? null : l;
    return (f || O.create(o, s, null)).weekdays(i);
  }, t.weekdaysFormat = function(i, e) {
    i === void 0 && (i = "long");
    var r = e === void 0 ? {} : e, a = r.locale, o = a === void 0 ? null : a, u = r.numberingSystem, s = u === void 0 ? null : u, l = r.locObj, f = l === void 0 ? null : l;
    return (f || O.create(o, s, null)).weekdays(i, !0);
  }, t.meridiems = function(i) {
    var e = i === void 0 ? {} : i, r = e.locale, a = r === void 0 ? null : r;
    return O.create(a).meridiems();
  }, t.eras = function(i, e) {
    i === void 0 && (i = "short");
    var r = e === void 0 ? {} : e, a = r.locale, o = a === void 0 ? null : a;
    return O.create(o, null, "gregory").eras(i);
  }, t.features = function() {
    return {
      relative: Mr(),
      localeWeek: Er()
    };
  }, t;
}();
function $t(t, n) {
  var i = function(a) {
    return a.toUTC(0, {
      keepLocalTime: !0
    }).startOf("day").valueOf();
  }, e = i(n) - i(t);
  return Math.floor(N.fromMillis(e).as("days"));
}
function Ji(t, n, i) {
  for (var e = [["years", function(m, v) {
    return v.year - m.year;
  }], ["quarters", function(m, v) {
    return v.quarter - m.quarter + (v.year - m.year) * 4;
  }], ["months", function(m, v) {
    return v.month - m.month + (v.year - m.year) * 12;
  }], ["weeks", function(m, v) {
    var w = $t(m, v);
    return (w - w % 7) / 7;
  }], ["days", $t]], r = {}, a = t, o, u, s = 0, l = e; s < l.length; s++) {
    var f = l[s], c = f[0], d = f[1];
    i.indexOf(c) >= 0 && (o = c, r[c] = d(t, n), u = a.plus(r), u > n ? (r[c]--, t = a.plus(r), t > n && (u = t, r[c]--, t = a.plus(r))) : t = u);
  }
  return [t, r, u, o];
}
function Bi(t, n, i, e) {
  var r = Ji(t, n, i), a = r[0], o = r[1], u = r[2], s = r[3], l = n - a, f = i.filter(function(v) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(v) >= 0;
  });
  if (f.length === 0) {
    if (u < n) {
      var c;
      u = a.plus((c = {}, c[s] = 1, c));
    }
    u !== a && (o[s] = (o[s] || 0) + l / (u - a));
  }
  var d = N.fromObject(o, e);
  if (f.length > 0) {
    var m;
    return (m = N.fromMillis(l, e)).shiftTo.apply(m, f).plus(d);
  } else
    return d;
}
var Qi = "missing Intl.DateTimeFormat.formatToParts support";
function T(t, n) {
  return n === void 0 && (n = function(e) {
    return e;
  }), {
    regex: t,
    deser: function(e) {
      var r = e[0];
      return n(zn(r));
    }
  };
}
var Ki = String.fromCharCode(160), jr = "[ " + Ki + "]", Gr = new RegExp(jr, "g");
function Xi(t) {
  return t.replace(/\./g, "\\.?").replace(Gr, jr);
}
function Ht(t) {
  return t.replace(/\./g, "").replace(Gr, " ").toLowerCase();
}
function _(t, n) {
  return t === null ? null : {
    regex: RegExp(t.map(Xi).join("|")),
    deser: function(e) {
      var r = e[0];
      return t.findIndex(function(a) {
        return Ht(r) === Ht(a);
      }) + n;
    }
  };
}
function Yt(t, n) {
  return {
    regex: t,
    deser: function(e) {
      var r = e[1], a = e[2];
      return He(r, a);
    },
    groups: n
  };
}
function xe(t) {
  return {
    regex: t,
    deser: function(i) {
      var e = i[0];
      return e;
    }
  };
}
function ea(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function ta(t, n) {
  var i = L(n), e = L(n, "{2}"), r = L(n, "{3}"), a = L(n, "{4}"), o = L(n, "{6}"), u = L(n, "{1,2}"), s = L(n, "{1,3}"), l = L(n, "{1,6}"), f = L(n, "{1,9}"), c = L(n, "{2,4}"), d = L(n, "{4,6}"), m = function(y) {
    return {
      regex: RegExp(ea(y.val)),
      deser: function(de) {
        var K = de[0];
        return K;
      },
      literal: !0
    };
  }, v = function(y) {
    if (t.literal)
      return m(y);
    switch (y.val) {
      case "G":
        return _(n.eras("short"), 0);
      case "GG":
        return _(n.eras("long"), 0);
      case "y":
        return T(l);
      case "yy":
        return T(c, st);
      case "yyyy":
        return T(a);
      case "yyyyy":
        return T(d);
      case "yyyyyy":
        return T(o);
      case "M":
        return T(u);
      case "MM":
        return T(e);
      case "MMM":
        return _(n.months("short", !0), 1);
      case "MMMM":
        return _(n.months("long", !0), 1);
      case "L":
        return T(u);
      case "LL":
        return T(e);
      case "LLL":
        return _(n.months("short", !1), 1);
      case "LLLL":
        return _(n.months("long", !1), 1);
      case "d":
        return T(u);
      case "dd":
        return T(e);
      case "o":
        return T(s);
      case "ooo":
        return T(r);
      case "HH":
        return T(e);
      case "H":
        return T(u);
      case "hh":
        return T(e);
      case "h":
        return T(u);
      case "mm":
        return T(e);
      case "m":
        return T(u);
      case "q":
        return T(u);
      case "qq":
        return T(e);
      case "s":
        return T(u);
      case "ss":
        return T(e);
      case "S":
        return T(s);
      case "SSS":
        return T(r);
      case "u":
        return xe(f);
      case "uu":
        return xe(u);
      case "uuu":
        return T(i);
      case "a":
        return _(n.meridiems(), 0);
      case "kkkk":
        return T(a);
      case "kk":
        return T(c, st);
      case "W":
        return T(u);
      case "WW":
        return T(e);
      case "E":
      case "c":
        return T(i);
      case "EEE":
        return _(n.weekdays("short", !1), 1);
      case "EEEE":
        return _(n.weekdays("long", !1), 1);
      case "ccc":
        return _(n.weekdays("short", !0), 1);
      case "cccc":
        return _(n.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return Yt(new RegExp("([+-]" + u.source + ")(?::(" + e.source + "))?"), 2);
      case "ZZZ":
        return Yt(new RegExp("([+-]" + u.source + ")(" + e.source + ")?"), 2);
      case "z":
        return xe(/[a-z_+-/]{1,256}?/i);
      case " ":
        return xe(/[^\S\n\r]/);
      default:
        return m(y);
    }
  }, w = v(t) || {
    invalidReason: Qi
  };
  return w.token = t, w;
}
var ra = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function na(t, n, i) {
  var e = t.type, r = t.value;
  if (e === "literal") {
    var a = /^\s+$/.test(r);
    return {
      literal: !a,
      val: a ? " " : r
    };
  }
  var o = n[e], u = e;
  e === "hour" && (n.hour12 != null ? u = n.hour12 ? "hour12" : "hour24" : n.hourCycle != null ? n.hourCycle === "h11" || n.hourCycle === "h12" ? u = "hour12" : u = "hour24" : u = i.hour12 ? "hour12" : "hour24");
  var s = ra[u];
  if (typeof s == "object" && (s = s[o]), s)
    return {
      literal: !1,
      val: s
    };
}
function ia(t) {
  var n = t.map(function(i) {
    return i.regex;
  }).reduce(function(i, e) {
    return i + "(" + e.source + ")";
  }, "");
  return ["^" + n + "$", t];
}
function aa(t, n, i) {
  var e = t.match(n);
  if (e) {
    var r = {}, a = 1;
    for (var o in i)
      if (oe(i, o)) {
        var u = i[o], s = u.groups ? u.groups + 1 : 1;
        !u.literal && u.token && (r[u.token.val[0]] = u.deser(e.slice(a, a + s))), a += s;
      }
    return [e, r];
  } else
    return [e, {}];
}
function oa(t) {
  var n = function(o) {
    switch (o) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  }, i = null, e;
  g(t.z) || (i = Q.create(t.z)), g(t.Z) || (i || (i = new R(t.Z)), e = t.Z), g(t.q) || (t.M = (t.q - 1) * 3 + 1), g(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), g(t.u) || (t.S = mt(t.u));
  var r = Object.keys(t).reduce(function(a, o) {
    var u = n(o);
    return u && (a[u] = t[o]), a;
  }, {});
  return [r, i, e];
}
var Be = null;
function ua() {
  return Be || (Be = D.fromMillis(1555555555555)), Be;
}
function sa(t, n) {
  if (t.literal)
    return t;
  var i = A.macroTokenToFormatOpts(t.val), e = Kr(i, n);
  return e == null || e.includes(void 0) ? t : e;
}
function Jr(t, n) {
  var i;
  return (i = Array.prototype).concat.apply(i, t.map(function(e) {
    return sa(e, n);
  }));
}
var Br = /* @__PURE__ */ function() {
  function t(i, e) {
    if (this.locale = i, this.format = e, this.tokens = Jr(A.parseFormat(e), i), this.units = this.tokens.map(function(u) {
      return ta(u, i);
    }), this.disqualifyingUnit = this.units.find(function(u) {
      return u.invalidReason;
    }), !this.disqualifyingUnit) {
      var r = ia(this.units), a = r[0], o = r[1];
      this.regex = RegExp(a, "i"), this.handlers = o;
    }
  }
  var n = t.prototype;
  return n.explainFromTokens = function(e) {
    if (this.isValid) {
      var r = aa(e, this.regex, this.handlers), a = r[0], o = r[1], u = o ? oa(o) : [null, null, void 0], s = u[0], l = u[1], f = u[2];
      if (oe(o, "a") && oe(o, "H"))
        throw new ne("Can't include meridiem when specifying 24-hour format");
      return {
        input: e,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: a,
        matches: o,
        result: s,
        zone: l,
        specificOffset: f
      };
    } else
      return {
        input: e,
        tokens: this.tokens,
        invalidReason: this.invalidReason
      };
  }, U(t, [{
    key: "isValid",
    get: function() {
      return !this.disqualifyingUnit;
    }
  }, {
    key: "invalidReason",
    get: function() {
      return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
    }
  }]), t;
}();
function Qr(t, n, i) {
  var e = new Br(t, i);
  return e.explainFromTokens(n);
}
function la(t, n, i) {
  var e = Qr(t, n, i), r = e.result, a = e.zone, o = e.specificOffset, u = e.invalidReason;
  return [r, a, o, u];
}
function Kr(t, n) {
  if (!t)
    return null;
  var i = A.create(n, t), e = i.dtFormatter(ua()), r = e.formatToParts(), a = e.resolvedOptions();
  return r.map(function(o) {
    return na(o, t, a);
  });
}
var Qe = "Invalid DateTime", jt = 864e13;
function Se(t) {
  return new Z("unsupported zone", 'the zone "' + t.name + '" is not supported');
}
function Ke(t) {
  return t.weekData === null && (t.weekData = ze(t.c)), t.weekData;
}
function Xe(t) {
  return t.localWeekData === null && (t.localWeekData = ze(t.c, t.loc.getMinDaysInFirstWeek(), t.loc.getStartOfWeek())), t.localWeekData;
}
function G(t, n) {
  var i = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new D(S({}, i, n, {
    old: i
  }));
}
function Xr(t, n, i) {
  var e = t - n * 60 * 1e3, r = i.offset(e);
  if (n === r)
    return [e, n];
  e -= (r - n) * 60 * 1e3;
  var a = i.offset(e);
  return r === a ? [e, r] : [t - Math.min(r, a) * 60 * 1e3, Math.max(r, a)];
}
function Ce(t, n) {
  t += n * 60 * 1e3;
  var i = new Date(t);
  return {
    year: i.getUTCFullYear(),
    month: i.getUTCMonth() + 1,
    day: i.getUTCDate(),
    hour: i.getUTCHours(),
    minute: i.getUTCMinutes(),
    second: i.getUTCSeconds(),
    millisecond: i.getUTCMilliseconds()
  };
}
function _e(t, n, i) {
  return Xr($e(t), n, i);
}
function Gt(t, n) {
  var i = t.o, e = t.c.year + Math.trunc(n.years), r = t.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, a = S({}, t.c, {
    year: e,
    month: r,
    day: Math.min(t.c.day, Ue(e, r)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }), o = N.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), u = $e(a), s = Xr(u, i, t.zone), l = s[0], f = s[1];
  return o !== 0 && (l += o, f = t.zone.offset(l)), {
    ts: l,
    o: f
  };
}
function te(t, n, i, e, r, a) {
  var o = i.setZone, u = i.zone;
  if (t && Object.keys(t).length !== 0 || n) {
    var s = n || u, l = D.fromObject(t, S({}, i, {
      zone: s,
      specificOffset: a
    }));
    return o ? l : l.setZone(u);
  } else
    return D.invalid(new Z("unparsable", 'the input "' + r + `" can't be parsed as ` + e));
}
function Ve(t, n, i) {
  return i === void 0 && (i = !0), t.isValid ? A.create(O.create("en-US"), {
    allowZ: i,
    forceSimple: !0
  }).formatDateTimeFromString(t, n) : null;
}
function et(t, n) {
  var i = t.c.year > 9999 || t.c.year < 0, e = "";
  return i && t.c.year >= 0 && (e += "+"), e += I(t.c.year, i ? 6 : 4), n ? (e += "-", e += I(t.c.month), e += "-", e += I(t.c.day)) : (e += I(t.c.month), e += I(t.c.day)), e;
}
function Jt(t, n, i, e, r, a) {
  var o = I(t.c.hour);
  return n ? (o += ":", o += I(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !i) && (o += ":")) : o += I(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !i) && (o += I(t.c.second), (t.c.millisecond !== 0 || !e) && (o += ".", o += I(t.c.millisecond, 3))), r && (t.isOffsetFixed && t.offset === 0 && !a ? o += "Z" : t.o < 0 ? (o += "-", o += I(Math.trunc(-t.o / 60)), o += ":", o += I(Math.trunc(-t.o % 60))) : (o += "+", o += I(Math.trunc(t.o / 60)), o += ":", o += I(Math.trunc(t.o % 60)))), a && (o += "[" + t.zone.ianaName + "]"), o;
}
var en = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, fa = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ca = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, tn = ["year", "month", "day", "hour", "minute", "second", "millisecond"], da = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"], ma = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function ha(t) {
  var n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!n)
    throw new tr(t);
  return n;
}
function Bt(t) {
  switch (t.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return ha(t);
  }
}
function va(t) {
  return Ze[t] || (Ae === void 0 && (Ae = p.now()), Ze[t] = t.offset(Ae)), Ze[t];
}
function Qt(t, n) {
  var i = H(n.zone, p.defaultZone);
  if (!i.isValid)
    return D.invalid(Se(i));
  var e = O.fromObject(n), r, a;
  if (g(t.year))
    r = p.now();
  else {
    for (var o = 0, u = tn; o < u.length; o++) {
      var s = u[o];
      g(t[s]) && (t[s] = en[s]);
    }
    var l = Ir(t) || Nr(t);
    if (l)
      return D.invalid(l);
    var f = va(i), c = _e(t, f, i);
    r = c[0], a = c[1];
  }
  return new D({
    ts: r,
    zone: i,
    loc: e,
    o: a
  });
}
function Kt(t, n, i) {
  var e = g(i.round) ? !0 : i.round, r = function(c, d) {
    c = ht(c, e || i.calendary ? 0 : 2, !0);
    var m = n.loc.clone(i).relFormatter(i);
    return m.format(c, d);
  }, a = function(c) {
    return i.calendary ? n.hasSame(t, c) ? 0 : n.startOf(c).diff(t.startOf(c), c).get(c) : n.diff(t, c).get(c);
  };
  if (i.unit)
    return r(a(i.unit), i.unit);
  for (var o = be(i.units), u; !(u = o()).done; ) {
    var s = u.value, l = a(s);
    if (Math.abs(l) >= 1)
      return r(l, s);
  }
  return r(t > n ? -0 : 0, i.units[i.units.length - 1]);
}
function Xt(t) {
  var n = {}, i;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (n = t[t.length - 1], i = Array.from(t).slice(0, t.length - 1)) : i = Array.from(t), [n, i];
}
var Ae, Ze = {}, D = /* @__PURE__ */ function(t) {
  function n(e) {
    var r = e.zone || p.defaultZone, a = e.invalid || (Number.isNaN(e.ts) ? new Z("invalid input") : null) || (r.isValid ? null : Se(r));
    this.ts = g(e.ts) ? p.now() : e.ts;
    var o = null, u = null;
    if (!a) {
      var s = e.old && e.old.ts === this.ts && e.old.zone.equals(r);
      if (s) {
        var l = [e.old.c, e.old.o];
        o = l[0], u = l[1];
      } else {
        var f = Y(e.o) && !e.old ? e.o : r.offset(this.ts);
        o = Ce(this.ts, f), a = Number.isNaN(o.year) ? new Z("invalid input") : null, o = a ? null : o, u = a ? null : f;
      }
    }
    this._zone = r, this.loc = e.loc || O.create(), this.invalid = a, this.weekData = null, this.localWeekData = null, this.c = o, this.o = u, this.isLuxonDateTime = !0;
  }
  n.now = function() {
    return new n({});
  }, n.local = function() {
    var r = Xt(arguments), a = r[0], o = r[1], u = o[0], s = o[1], l = o[2], f = o[3], c = o[4], d = o[5], m = o[6];
    return Qt({
      year: u,
      month: s,
      day: l,
      hour: f,
      minute: c,
      second: d,
      millisecond: m
    }, a);
  }, n.utc = function() {
    var r = Xt(arguments), a = r[0], o = r[1], u = o[0], s = o[1], l = o[2], f = o[3], c = o[4], d = o[5], m = o[6];
    return a.zone = R.utcInstance, Qt({
      year: u,
      month: s,
      day: l,
      hour: f,
      minute: c,
      second: d,
      millisecond: m
    }, a);
  }, n.fromJSDate = function(r, a) {
    a === void 0 && (a = {});
    var o = Hn(r) ? r.valueOf() : NaN;
    if (Number.isNaN(o))
      return n.invalid("invalid input");
    var u = H(a.zone, p.defaultZone);
    return u.isValid ? new n({
      ts: o,
      zone: u,
      loc: O.fromObject(a)
    }) : n.invalid(Se(u));
  }, n.fromMillis = function(r, a) {
    if (a === void 0 && (a = {}), Y(r))
      return r < -jt || r > jt ? n.invalid("Timestamp out of range") : new n({
        ts: r,
        zone: H(a.zone, p.defaultZone),
        loc: O.fromObject(a)
      });
    throw new M("fromMillis requires a numerical input, but received a " + typeof r + " with value " + r);
  }, n.fromSeconds = function(r, a) {
    if (a === void 0 && (a = {}), Y(r))
      return new n({
        ts: r * 1e3,
        zone: H(a.zone, p.defaultZone),
        loc: O.fromObject(a)
      });
    throw new M("fromSeconds requires a numerical input");
  }, n.fromObject = function(r, a) {
    a === void 0 && (a = {}), r = r || {};
    var o = H(a.zone, p.defaultZone);
    if (!o.isValid)
      return n.invalid(Se(o));
    var u = O.fromObject(a), s = qe(r, Bt), l = At(s, u), f = l.minDaysInFirstWeek, c = l.startOfWeek, d = p.now(), m = g(a.specificOffset) ? o.offset(d) : a.specificOffset, v = !g(s.ordinal), w = !g(s.year), k = !g(s.month) || !g(s.day), y = w || k, b = s.weekYear || s.weekNumber;
    if ((y || v) && b)
      throw new ne("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    if (k && v)
      throw new ne("Can't mix ordinal dates with month/day");
    var de = b || s.weekday && !y, K, Me, me = Ce(d, m);
    de ? (K = da, Me = fa, me = ze(me, f, c)) : v ? (K = ma, Me = ca, me = Je(me)) : (K = tn, Me = en);
    for (var wt = !1, rn = be(K), St; !(St = rn()).done; ) {
      var he = St.value, nn = s[he];
      g(nn) ? wt ? s[he] = Me[he] : s[he] = me[he] : wt = !0;
    }
    var an = de ? qn(s, f, c) : v ? Pn(s) : Ir(s), kt = an || Nr(s);
    if (kt)
      return n.invalid(kt);
    var on = de ? Lt(s, f, c) : v ? _t(s) : s, Tt = _e(on, m, o), un = Tt[0], sn = Tt[1], ve = new n({
      ts: un,
      zone: o,
      o: sn,
      loc: u
    });
    return s.weekday && y && r.weekday !== ve.weekday ? n.invalid("mismatched weekday", "you can't specify both a weekday of " + s.weekday + " and a date of " + ve.toISO()) : ve.isValid ? ve : n.invalid(ve.invalid);
  }, n.fromISO = function(r, a) {
    a === void 0 && (a = {});
    var o = Wi(r), u = o[0], s = o[1];
    return te(u, s, a, "ISO 8601", r);
  }, n.fromRFC2822 = function(r, a) {
    a === void 0 && (a = {});
    var o = Li(r), u = o[0], s = o[1];
    return te(u, s, a, "RFC 2822", r);
  }, n.fromHTTP = function(r, a) {
    a === void 0 && (a = {});
    var o = _i(r), u = o[0], s = o[1];
    return te(u, s, a, "HTTP", a);
  }, n.fromFormat = function(r, a, o) {
    if (o === void 0 && (o = {}), g(r) || g(a))
      throw new M("fromFormat requires an input string and a format");
    var u = o, s = u.locale, l = s === void 0 ? null : s, f = u.numberingSystem, c = f === void 0 ? null : f, d = O.fromOpts({
      locale: l,
      numberingSystem: c,
      defaultToEN: !0
    }), m = la(d, r, a), v = m[0], w = m[1], k = m[2], y = m[3];
    return y ? n.invalid(y) : te(v, w, o, "format " + a, r, k);
  }, n.fromString = function(r, a, o) {
    return o === void 0 && (o = {}), n.fromFormat(r, a, o);
  }, n.fromSQL = function(r, a) {
    a === void 0 && (a = {});
    var o = Pi(r), u = o[0], s = o[1];
    return te(u, s, a, "SQL", r);
  }, n.invalid = function(r, a) {
    if (a === void 0 && (a = null), !r)
      throw new M("need to specify a reason the DateTime is invalid");
    var o = r instanceof Z ? r : new Z(r, a);
    if (p.throwOnInvalid)
      throw new hn(o);
    return new n({
      invalid: o
    });
  }, n.isDateTime = function(r) {
    return r && r.isLuxonDateTime || !1;
  }, n.parseFormatForOpts = function(r, a) {
    a === void 0 && (a = {});
    var o = Kr(r, O.fromObject(a));
    return o ? o.map(function(u) {
      return u ? u.val : null;
    }).join("") : null;
  }, n.expandFormat = function(r, a) {
    a === void 0 && (a = {});
    var o = Jr(A.parseFormat(r), O.fromObject(a));
    return o.map(function(u) {
      return u.val;
    }).join("");
  }, n.resetCache = function() {
    Ae = void 0, Ze = {};
  };
  var i = n.prototype;
  return i.get = function(r) {
    return this[r];
  }, i.getPossibleOffsets = function() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    var r = 864e5, a = 6e4, o = $e(this.c), u = this.zone.offset(o - r), s = this.zone.offset(o + r), l = this.zone.offset(o - u * a), f = this.zone.offset(o - s * a);
    if (l === f)
      return [this];
    var c = o - l * a, d = o - f * a, m = Ce(c, l), v = Ce(d, f);
    return m.hour === v.hour && m.minute === v.minute && m.second === v.second && m.millisecond === v.millisecond ? [G(this, {
      ts: c
    }), G(this, {
      ts: d
    })] : [this];
  }, i.resolvedLocaleOptions = function(r) {
    r === void 0 && (r = {});
    var a = A.create(this.loc.clone(r), r).resolvedOptions(this), o = a.locale, u = a.numberingSystem, s = a.calendar;
    return {
      locale: o,
      numberingSystem: u,
      outputCalendar: s
    };
  }, i.toUTC = function(r, a) {
    return r === void 0 && (r = 0), a === void 0 && (a = {}), this.setZone(R.instance(r), a);
  }, i.toLocal = function() {
    return this.setZone(p.defaultZone);
  }, i.setZone = function(r, a) {
    var o = a === void 0 ? {} : a, u = o.keepLocalTime, s = u === void 0 ? !1 : u, l = o.keepCalendarTime, f = l === void 0 ? !1 : l;
    if (r = H(r, p.defaultZone), r.equals(this.zone))
      return this;
    if (r.isValid) {
      var c = this.ts;
      if (s || f) {
        var d = r.offset(this.ts), m = this.toObject(), v = _e(m, d, r);
        c = v[0];
      }
      return G(this, {
        ts: c,
        zone: r
      });
    } else
      return n.invalid(Se(r));
  }, i.reconfigure = function(r) {
    var a = r === void 0 ? {} : r, o = a.locale, u = a.numberingSystem, s = a.outputCalendar, l = this.loc.clone({
      locale: o,
      numberingSystem: u,
      outputCalendar: s
    });
    return G(this, {
      loc: l
    });
  }, i.setLocale = function(r) {
    return this.reconfigure({
      locale: r
    });
  }, i.set = function(r) {
    if (!this.isValid)
      return this;
    var a = qe(r, Bt), o = At(a, this.loc), u = o.minDaysInFirstWeek, s = o.startOfWeek, l = !g(a.weekYear) || !g(a.weekNumber) || !g(a.weekday), f = !g(a.ordinal), c = !g(a.year), d = !g(a.month) || !g(a.day), m = c || d, v = a.weekYear || a.weekNumber;
    if ((m || f) && v)
      throw new ne("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    if (d && f)
      throw new ne("Can't mix ordinal dates with month/day");
    var w;
    l ? w = Lt(S({}, ze(this.c, u, s), a), u, s) : g(a.ordinal) ? (w = S({}, this.toObject(), a), g(a.day) && (w.day = Math.min(Ue(w.year, w.month), w.day))) : w = _t(S({}, Je(this.c), a));
    var k = _e(w, this.o, this.zone), y = k[0], b = k[1];
    return G(this, {
      ts: y,
      o: b
    });
  }, i.plus = function(r) {
    if (!this.isValid)
      return this;
    var a = N.fromDurationLike(r);
    return G(this, Gt(this, a));
  }, i.minus = function(r) {
    if (!this.isValid)
      return this;
    var a = N.fromDurationLike(r).negate();
    return G(this, Gt(this, a));
  }, i.startOf = function(r, a) {
    var o = a === void 0 ? {} : a, u = o.useLocaleWeeks, s = u === void 0 ? !1 : u;
    if (!this.isValid)
      return this;
    var l = {}, f = N.normalizeUnit(r);
    switch (f) {
      case "years":
        l.month = 1;
      case "quarters":
      case "months":
        l.day = 1;
      case "weeks":
      case "days":
        l.hour = 0;
      case "hours":
        l.minute = 0;
      case "minutes":
        l.second = 0;
      case "seconds":
        l.millisecond = 0;
        break;
    }
    if (f === "weeks")
      if (s) {
        var c = this.loc.getStartOfWeek(), d = this.weekday;
        d < c && (l.weekNumber = this.weekNumber - 1), l.weekday = c;
      } else
        l.weekday = 1;
    if (f === "quarters") {
      var m = Math.ceil(this.month / 3);
      l.month = (m - 1) * 3 + 1;
    }
    return this.set(l);
  }, i.endOf = function(r, a) {
    var o;
    return this.isValid ? this.plus((o = {}, o[r] = 1, o)).startOf(r, a).minus(1) : this;
  }, i.toFormat = function(r, a) {
    return a === void 0 && (a = {}), this.isValid ? A.create(this.loc.redefaultToEN(a)).formatDateTimeFromString(this, r) : Qe;
  }, i.toLocaleString = function(r, a) {
    return r === void 0 && (r = Re), a === void 0 && (a = {}), this.isValid ? A.create(this.loc.clone(a), r).formatDateTime(this) : Qe;
  }, i.toLocaleParts = function(r) {
    return r === void 0 && (r = {}), this.isValid ? A.create(this.loc.clone(r), r).formatDateTimeParts(this) : [];
  }, i.toISO = function(r) {
    var a = r === void 0 ? {} : r, o = a.format, u = o === void 0 ? "extended" : o, s = a.suppressSeconds, l = s === void 0 ? !1 : s, f = a.suppressMilliseconds, c = f === void 0 ? !1 : f, d = a.includeOffset, m = d === void 0 ? !0 : d, v = a.extendedZone, w = v === void 0 ? !1 : v;
    if (!this.isValid)
      return null;
    var k = u === "extended", y = et(this, k);
    return y += "T", y += Jt(this, k, l, c, m, w), y;
  }, i.toISODate = function(r) {
    var a = r === void 0 ? {} : r, o = a.format, u = o === void 0 ? "extended" : o;
    return this.isValid ? et(this, u === "extended") : null;
  }, i.toISOWeekDate = function() {
    return Ve(this, "kkkk-'W'WW-c");
  }, i.toISOTime = function(r) {
    var a = r === void 0 ? {} : r, o = a.suppressMilliseconds, u = o === void 0 ? !1 : o, s = a.suppressSeconds, l = s === void 0 ? !1 : s, f = a.includeOffset, c = f === void 0 ? !0 : f, d = a.includePrefix, m = d === void 0 ? !1 : d, v = a.extendedZone, w = v === void 0 ? !1 : v, k = a.format, y = k === void 0 ? "extended" : k;
    if (!this.isValid)
      return null;
    var b = m ? "T" : "";
    return b + Jt(this, y === "extended", l, u, c, w);
  }, i.toRFC2822 = function() {
    return Ve(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }, i.toHTTP = function() {
    return Ve(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }, i.toSQLDate = function() {
    return this.isValid ? et(this, !0) : null;
  }, i.toSQLTime = function(r) {
    var a = r === void 0 ? {} : r, o = a.includeOffset, u = o === void 0 ? !0 : o, s = a.includeZone, l = s === void 0 ? !1 : s, f = a.includeOffsetSpace, c = f === void 0 ? !0 : f, d = "HH:mm:ss.SSS";
    return (l || u) && (c && (d += " "), l ? d += "z" : u && (d += "ZZ")), Ve(this, d, !0);
  }, i.toSQL = function(r) {
    return r === void 0 && (r = {}), this.isValid ? this.toSQLDate() + " " + this.toSQLTime(r) : null;
  }, i.toString = function() {
    return this.isValid ? this.toISO() : Qe;
  }, i[t] = function() {
    return this.isValid ? "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }" : "DateTime { Invalid, reason: " + this.invalidReason + " }";
  }, i.valueOf = function() {
    return this.toMillis();
  }, i.toMillis = function() {
    return this.isValid ? this.ts : NaN;
  }, i.toSeconds = function() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }, i.toUnixInteger = function() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }, i.toJSON = function() {
    return this.toISO();
  }, i.toBSON = function() {
    return this.toJSDate();
  }, i.toObject = function(r) {
    if (r === void 0 && (r = {}), !this.isValid)
      return {};
    var a = S({}, this.c);
    return r.includeConfig && (a.outputCalendar = this.outputCalendar, a.numberingSystem = this.loc.numberingSystem, a.locale = this.loc.locale), a;
  }, i.toJSDate = function() {
    return new Date(this.isValid ? this.ts : NaN);
  }, i.diff = function(r, a, o) {
    if (a === void 0 && (a = "milliseconds"), o === void 0 && (o = {}), !this.isValid || !r.isValid)
      return N.invalid("created by diffing an invalid DateTime");
    var u = S({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, o), s = Yn(a).map(N.normalizeUnit), l = r.valueOf() > this.valueOf(), f = l ? this : r, c = l ? r : this, d = Bi(f, c, s, u);
    return l ? d.negate() : d;
  }, i.diffNow = function(r, a) {
    return r === void 0 && (r = "milliseconds"), a === void 0 && (a = {}), this.diff(n.now(), r, a);
  }, i.until = function(r) {
    return this.isValid ? Te.fromDateTimes(this, r) : this;
  }, i.hasSame = function(r, a, o) {
    if (!this.isValid)
      return !1;
    var u = r.valueOf(), s = this.setZone(r.zone, {
      keepLocalTime: !0
    });
    return s.startOf(a, o) <= u && u <= s.endOf(a, o);
  }, i.equals = function(r) {
    return this.isValid && r.isValid && this.valueOf() === r.valueOf() && this.zone.equals(r.zone) && this.loc.equals(r.loc);
  }, i.toRelative = function(r) {
    if (r === void 0 && (r = {}), !this.isValid)
      return null;
    var a = r.base || n.fromObject({}, {
      zone: this.zone
    }), o = r.padding ? this < a ? -r.padding : r.padding : 0, u = ["years", "months", "days", "hours", "minutes", "seconds"], s = r.unit;
    return Array.isArray(r.unit) && (u = r.unit, s = void 0), Kt(a, this.plus(o), S({}, r, {
      numeric: "always",
      units: u,
      unit: s
    }));
  }, i.toRelativeCalendar = function(r) {
    return r === void 0 && (r = {}), this.isValid ? Kt(r.base || n.fromObject({}, {
      zone: this.zone
    }), this, S({}, r, {
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    })) : null;
  }, n.min = function() {
    for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
      a[o] = arguments[o];
    if (!a.every(n.isDateTime))
      throw new M("min requires all arguments be DateTimes");
    return Zt(a, function(u) {
      return u.valueOf();
    }, Math.min);
  }, n.max = function() {
    for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
      a[o] = arguments[o];
    if (!a.every(n.isDateTime))
      throw new M("max requires all arguments be DateTimes");
    return Zt(a, function(u) {
      return u.valueOf();
    }, Math.max);
  }, n.fromFormatExplain = function(r, a, o) {
    o === void 0 && (o = {});
    var u = o, s = u.locale, l = s === void 0 ? null : s, f = u.numberingSystem, c = f === void 0 ? null : f, d = O.fromOpts({
      locale: l,
      numberingSystem: c,
      defaultToEN: !0
    });
    return Qr(d, r, a);
  }, n.fromStringExplain = function(r, a, o) {
    return o === void 0 && (o = {}), n.fromFormatExplain(r, a, o);
  }, n.buildFormatParser = function(r, a) {
    a === void 0 && (a = {});
    var o = a, u = o.locale, s = u === void 0 ? null : u, l = o.numberingSystem, f = l === void 0 ? null : l, c = O.fromOpts({
      locale: s,
      numberingSystem: f,
      defaultToEN: !0
    });
    return new Br(c, r);
  }, n.fromFormatParser = function(r, a, o) {
    if (o === void 0 && (o = {}), g(r) || g(a))
      throw new M("fromFormatParser requires an input string and a format parser");
    var u = o, s = u.locale, l = s === void 0 ? null : s, f = u.numberingSystem, c = f === void 0 ? null : f, d = O.fromOpts({
      locale: l,
      numberingSystem: c,
      defaultToEN: !0
    });
    if (!d.equals(a.locale))
      throw new M("fromFormatParser called with a locale of " + d + ", " + ("but the format parser was created for " + a.locale));
    var m = a.explainFromTokens(r), v = m.result, w = m.zone, k = m.specificOffset, y = m.invalidReason;
    return y ? n.invalid(y) : te(v, w, o, "format " + a.format, r, k);
  }, U(n, [{
    key: "isValid",
    get: function() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
     * @type {string}
     */
  }, {
    key: "invalidReason",
    get: function() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */
  }, {
    key: "invalidExplanation",
    get: function() {
      return this.invalid ? this.invalid.explanation : null;
    }
    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "locale",
    get: function() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "numberingSystem",
    get: function() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */
  }, {
    key: "outputCalendar",
    get: function() {
      return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
     * Get the time zone associated with this DateTime.
     * @type {Zone}
     */
  }, {
    key: "zone",
    get: function() {
      return this._zone;
    }
    /**
     * Get the name of the time zone.
     * @type {string}
     */
  }, {
    key: "zoneName",
    get: function() {
      return this.isValid ? this.zone.name : null;
    }
    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */
  }, {
    key: "year",
    get: function() {
      return this.isValid ? this.c.year : NaN;
    }
    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */
  }, {
    key: "quarter",
    get: function() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */
  }, {
    key: "month",
    get: function() {
      return this.isValid ? this.c.month : NaN;
    }
    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */
  }, {
    key: "day",
    get: function() {
      return this.isValid ? this.c.day : NaN;
    }
    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */
  }, {
    key: "hour",
    get: function() {
      return this.isValid ? this.c.hour : NaN;
    }
    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */
  }, {
    key: "minute",
    get: function() {
      return this.isValid ? this.c.minute : NaN;
    }
    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */
  }, {
    key: "second",
    get: function() {
      return this.isValid ? this.c.second : NaN;
    }
    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */
  }, {
    key: "millisecond",
    get: function() {
      return this.isValid ? this.c.millisecond : NaN;
    }
    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
     * @type {number}
     */
  }, {
    key: "weekYear",
    get: function() {
      return this.isValid ? Ke(this).weekYear : NaN;
    }
    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */
  }, {
    key: "weekNumber",
    get: function() {
      return this.isValid ? Ke(this).weekNumber : NaN;
    }
    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */
  }, {
    key: "weekday",
    get: function() {
      return this.isValid ? Ke(this).weekday : NaN;
    }
    /**
     * Returns true if this date is on a weekend according to the locale, false otherwise
     * @returns {boolean}
     */
  }, {
    key: "isWeekend",
    get: function() {
      return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }
    /**
     * Get the day of the week according to the locale.
     * 1 is the first day of the week and 7 is the last day of the week.
     * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
     * @returns {number}
     */
  }, {
    key: "localWeekday",
    get: function() {
      return this.isValid ? Xe(this).weekday : NaN;
    }
    /**
     * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
     * because the week can start on different days of the week (see localWeekday) and because a different number of days
     * is required for a week to count as the first week of a year.
     * @returns {number}
     */
  }, {
    key: "localWeekNumber",
    get: function() {
      return this.isValid ? Xe(this).weekNumber : NaN;
    }
    /**
     * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
     * differently, see localWeekNumber.
     * @returns {number}
     */
  }, {
    key: "localWeekYear",
    get: function() {
      return this.isValid ? Xe(this).weekYear : NaN;
    }
    /**
     * Get the ordinal (meaning the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */
  }, {
    key: "ordinal",
    get: function() {
      return this.isValid ? Je(this.c).ordinal : NaN;
    }
    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */
  }, {
    key: "monthShort",
    get: function() {
      return this.isValid ? we.months("short", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */
  }, {
    key: "monthLong",
    get: function() {
      return this.isValid ? we.months("long", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */
  }, {
    key: "weekdayShort",
    get: function() {
      return this.isValid ? we.weekdays("short", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */
  }, {
    key: "weekdayLong",
    get: function() {
      return this.isValid ? we.weekdays("long", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.now().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */
  }, {
    key: "offset",
    get: function() {
      return this.isValid ? +this.o : NaN;
    }
    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */
  }, {
    key: "offsetNameShort",
    get: function() {
      return this.isValid ? this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      }) : null;
    }
    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */
  }, {
    key: "offsetNameLong",
    get: function() {
      return this.isValid ? this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      }) : null;
    }
    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */
  }, {
    key: "isOffsetFixed",
    get: function() {
      return this.isValid ? this.zone.isUniversal : null;
    }
    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */
  }, {
    key: "isInDST",
    get: function() {
      return this.isOffsetFixed ? !1 : this.offset > this.set({
        month: 1,
        day: 1
      }).offset || this.offset > this.set({
        month: 5
      }).offset;
    }
  }, {
    key: "isInLeapYear",
    get: function() {
      return De(this.year);
    }
    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */
  }, {
    key: "daysInMonth",
    get: function() {
      return Ue(this.year, this.month);
    }
    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */
  }, {
    key: "daysInYear",
    get: function() {
      return this.isValid ? ie(this.year) : NaN;
    }
    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */
  }, {
    key: "weeksInWeekYear",
    get: function() {
      return this.isValid ? pe(this.weekYear) : NaN;
    }
    /**
     * Returns the number of weeks in this DateTime's local week year
     * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
     * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
     * @type {number}
     */
  }, {
    key: "weeksInLocalWeekYear",
    get: function() {
      return this.isValid ? pe(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
  }], [{
    key: "DATE_SHORT",
    get: function() {
      return Re;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_MED",
    get: function() {
      return rr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_MED_WITH_WEEKDAY",
    get: function() {
      return gn;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_FULL",
    get: function() {
      return nr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */
  }, {
    key: "DATE_HUGE",
    get: function() {
      return ir;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_SIMPLE",
    get: function() {
      return ar;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_SECONDS",
    get: function() {
      return or;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_SHORT_OFFSET",
    get: function() {
      return ur;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "TIME_WITH_LONG_OFFSET",
    get: function() {
      return sr;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_SIMPLE",
    get: function() {
      return lr;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_SECONDS",
    get: function() {
      return fr;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_SHORT_OFFSET",
    get: function() {
      return cr;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */
  }, {
    key: "TIME_24_WITH_LONG_OFFSET",
    get: function() {
      return dr;
    }
    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_SHORT",
    get: function() {
      return mr;
    }
    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_SHORT_WITH_SECONDS",
    get: function() {
      return hr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED",
    get: function() {
      return vr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED_WITH_SECONDS",
    get: function() {
      return yr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_MED_WITH_WEEKDAY",
    get: function() {
      return wn;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_FULL",
    get: function() {
      return gr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_FULL_WITH_SECONDS",
    get: function() {
      return wr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_HUGE",
    get: function() {
      return Sr;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */
  }, {
    key: "DATETIME_HUGE_WITH_SECONDS",
    get: function() {
      return kr;
    }
  }]), n;
}(Symbol.for("nodejs.util.inspect.custom"));
function ye(t) {
  if (D.isDateTime(t))
    return t;
  if (t && t.valueOf && Y(t.valueOf()))
    return D.fromJSDate(t);
  if (t && typeof t == "object")
    return D.fromObject(t);
  throw new M("Unknown datetime argument: " + t + ", of type " + typeof t);
}
var ya = "3.5.0", ga = V.DateTime = D;
V.Duration = N;
V.FixedOffsetZone = R;
V.IANAZone = Q;
V.Info = we;
V.Interval = Te;
V.InvalidZone = Tr;
V.Settings = p;
V.SystemZone = lt;
V.VERSION = ya;
V.Zone = ue;
export {
  ga as D
};
